/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  StringOrStringArray: { input: any; output: any; }
};

export type AddClinicalEvidenceEntryInput = {
  abstract: Scalars['String']['input'];
  citation: Scalars['String']['input'];
  condition: Scalars['String']['input'];
  medication: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * At some point I think we will want to roll this together with the ConfirmDetailsInput.
 *
 * This may depend on how the rework of the madlib page pans out.
 */
export type AdditionalInsuranceInformationInput = {
  claimId?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  memberNumber: Scalars['String']['input'];
  planCategory: PlanCategory;
  rxGroupNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type Appeal = {
  __typename?: 'Appeal';
  appealId: Scalars['ID']['output'];
  appealLetter?: Maybe<AppealLetter>;
  appealType?: Maybe<AppealType>;
  caregiver?: Maybe<Caregiver>;
  ccDestinations: Array<CcDestination>;
  couponId?: Maybe<Scalars['String']['output']>;
  createdTimestamp: Scalars['Date']['output'];
  denial?: Maybe<Denial>;
  destination?: Maybe<AppealDestination>;
  formattedSurveyAnswers?: Maybe<Scalars['String']['output']>;
  isCoverageFund: Scalars['Boolean']['output'];
  isExpeditedReview?: Maybe<Scalars['Boolean']['output']>;
  originalAppealId?: Maybe<Scalars['ID']['output']>;
  partnerId?: Maybe<Scalars['ID']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerPatientEmail?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  patientInsurance?: Maybe<PatientInsurance>;
  referral?: Maybe<ProviderReferral>;
  referralId?: Maybe<Scalars['String']['output']>;
  referralPatientEmail?: Maybe<Scalars['String']['output']>;
  referringFacilityId?: Maybe<Scalars['String']['output']>;
  referringFacilityName?: Maybe<Scalars['String']['output']>;
  referringFacilityShortName?: Maybe<Scalars['String']['output']>;
  referringProviderId?: Maybe<Scalars['String']['output']>;
  referringProviderName?: Maybe<Scalars['String']['output']>;
  referringProviderType?: Maybe<ProviderType>;
  sentFaxes: Array<SentFax>;
  sentLetters: Array<SentLetter>;
  sponsoringParty?: Maybe<SponsoringParty>;
  sponsorshipExpiredTimestamp?: Maybe<Scalars['Date']['output']>;
  status: AppealStatus;
  supportingDocuments?: Maybe<Array<AppealSupportingDocument>>;
  surveyAnswers: Array<SurveyAnswer>;
  surveyId?: Maybe<Scalars['ID']['output']>;
  surveyJsAnswers: Scalars['String']['output'];
  updatedTimestamp: Scalars['Date']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};


export type AppealSupportingDocumentsArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppealDestination = {
  __typename?: 'AppealDestination';
  address?: Maybe<Address>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  recipientType: RecipientType;
};

export type AppealDestinationInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientType: RecipientType;
};

export type AppealLetter = {
  __typename?: 'AppealLetter';
  body: Scalars['String']['output'];
  references: Scalars['String']['output'];
};

export type AppealLetterInput = {
  body: Scalars['String']['input'];
  references: Scalars['String']['input'];
};

export type AppealLetterIssueInput = {
  categories: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
};

export enum AppealPackage {
  OneHundredPack = 'ONE_HUNDRED_PACK',
  TenPack = 'TEN_PACK',
  ThirtyPack = 'THIRTY_PACK'
}

export type AppealStatus = {
  __typename?: 'AppealStatus';
  appealLetterGenerated?: Maybe<Scalars['Boolean']['output']>;
  appealSubmitted?: Maybe<Scalars['Boolean']['output']>;
  appealSubmittedTimestamp?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  denialLetterExtracted?: Maybe<Scalars['Boolean']['output']>;
  denialLetterExtractionFailed?: Maybe<Scalars['Boolean']['output']>;
  denialLetterUpload?: Maybe<Scalars['Boolean']['output']>;
  denialLetterUploadSkipped?: Maybe<Scalars['Boolean']['output']>;
  denialOverturned?: Maybe<Scalars['Boolean']['output']>;
  denialOverturnedTimestamp?: Maybe<Scalars['String']['output']>;
  denialUpheld?: Maybe<Scalars['Boolean']['output']>;
  denialUpheldTimestamp?: Maybe<Scalars['String']['output']>;
  enterpriseSubmissionInitiated?: Maybe<Scalars['Boolean']['output']>;
  failedSendingAllAppeals?: Maybe<Scalars['Boolean']['output']>;
  informationConfirmed?: Maybe<Scalars['Boolean']['output']>;
  initiated?: Maybe<Scalars['Boolean']['output']>;
  insuranceCardExtracted?: Maybe<Scalars['Boolean']['output']>;
  insuranceCardExtractionFailed?: Maybe<Scalars['Boolean']['output']>;
  insuranceCardUpload?: Maybe<Scalars['Boolean']['output']>;
  insuranceCardUploadSkipped?: Maybe<Scalars['Boolean']['output']>;
  issueOutstanding?: Maybe<Scalars['Boolean']['output']>;
  letterGenerationFailed?: Maybe<Scalars['Boolean']['output']>;
  letterOfMedicalNecessityUploaded?: Maybe<Scalars['Boolean']['output']>;
  patientSavedExperience?: Maybe<Scalars['Boolean']['output']>;
  paymentFailed?: Maybe<Scalars['Boolean']['output']>;
  paymentSuccessful?: Maybe<Scalars['Boolean']['output']>;
  pdfGenerated?: Maybe<Scalars['Boolean']['output']>;
  pdfGenerationFailed?: Maybe<Scalars['Boolean']['output']>;
  referred?: Maybe<Scalars['Boolean']['output']>;
  secondAppealRequested?: Maybe<Scalars['Boolean']['output']>;
  secondAppealRequestedTimestamp?: Maybe<Scalars['String']['output']>;
};

export type AppealSupportingDocument = {
  __typename?: 'AppealSupportingDocument';
  documentId: Scalars['ID']['output'];
  documentType: AppealSupportingDocumentType;
  files: Array<AppealSupportingDocumentFile>;
  isIncludedInAppeal: Scalars['Boolean']['output'];
  otherDocumentTypeName?: Maybe<Scalars['String']['output']>;
  uploadedBy: AppealSupportingDocumentUploadedBy;
};

export type AppealSupportingDocumentFile = {
  __typename?: 'AppealSupportingDocumentFile';
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  fileType: AppealSupportingDocumentFileType;
  url: Scalars['String']['output'];
};

export type AppealSupportingDocumentFileInput = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
  fileName: Scalars['String']['input'];
  fileType: AppealSupportingDocumentFileType;
};

export enum AppealSupportingDocumentFileType {
  Image = 'IMAGE',
  Pdf = 'PDF'
}

export enum AppealSupportingDocumentType {
  CoverLetter = 'COVER_LETTER',
  InsuranceForm = 'INSURANCE_FORM',
  LabResults = 'LAB_RESULTS',
  LetterOfMedicalNecessity = 'LETTER_OF_MEDICAL_NECESSITY',
  MedicalRecords = 'MEDICAL_RECORDS',
  Other = 'OTHER',
  PatientConsent = 'PATIENT_CONSENT'
}

export enum AppealSupportingDocumentUploadedBy {
  Patient = 'PATIENT',
  Provider = 'PROVIDER',
  Support = 'SUPPORT'
}

export enum AppealType {
  Dependent = 'DEPENDENT',
  Self = 'SELF'
}

export type AppealsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<AppealsSearchTermsInput>;
};

export type AppealsSearchTermsInput = {
  appealLevel?: InputMaybe<Array<Scalars['String']['input']>>;
  appealStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<Array<Scalars['String']['input']>>;
  isCoverageFund?: InputMaybe<Scalars['Boolean']['input']>;
  medication?: InputMaybe<Array<Scalars['String']['input']>>;
  patientEmail?: InputMaybe<Scalars['String']['input']>;
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  providerUserEmail?: InputMaybe<Scalars['String']['input']>;
  secondAppealRequested?: InputMaybe<Scalars['Boolean']['input']>;
  shouldFilterOutAppealsWithoutOpenSupportRequests?: InputMaybe<Scalars['Boolean']['input']>;
  shouldFilterOutInternalUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ApprovalStatus {
  All = 'ALL',
  Approved = 'APPROVED',
  Unapproved = 'UNAPPROVED'
}

export type Caregiver = {
  __typename?: 'Caregiver';
  dateOfBirth: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  relationship: CaregiverRelationship;
};

export type CaregiverInfoInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  relationship: CaregiverRelationship;
};

export type CaregiverInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  relationship: CaregiverRelationship;
};

export enum CaregiverRelationship {
  AuthorizedRepresentative = 'AUTHORIZED_REPRESENTATIVE',
  Father = 'FATHER',
  Mother = 'MOTHER',
  OtherLegalGuardian = 'OTHER_LEGAL_GUARDIAN'
}

export type CcDestination = {
  __typename?: 'CcDestination';
  destination: AppealDestination;
  sendMethod: SendMethod;
};

export type CcDestinationInput = {
  destination: AppealDestinationInput;
  sendMethod: SendMethod;
};

export type ClinicalEvidence = {
  __typename?: 'ClinicalEvidence';
  abstract: Scalars['String']['output'];
  citation: Scalars['String']['output'];
  condition: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  medication: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type ClinicalEvidenceQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<EvidenceSearchTermsInput>;
};

export type ConfirmDetailsInput = {
  employer?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceProvider: Scalars['String']['input'];
  memberNumber: Scalars['String']['input'];
  pbmName?: InputMaybe<Scalars['String']['input']>;
  planCategory: PlanCategory;
  rxBinNumber?: InputMaybe<Scalars['String']['input']>;
  rxGroupNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProviderViaSelfSignUpInput = {
  identificationNumber: Scalars['String']['input'];
  organizationType: OrganizationType;
  providerName: Scalars['String']['input'];
  specialty?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSurveySchemaInput = {
  condition: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  schemaData: Scalars['String']['input'];
};

export type Denial = {
  __typename?: 'Denial';
  bmiComorbidCriteria?: Maybe<Scalars['Float']['output']>;
  bmiObesityCriteria?: Maybe<Scalars['Float']['output']>;
  claimId?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  daysToAppeal?: Maybe<Scalars['Int']['output']>;
  denialDate?: Maybe<Scalars['Date']['output']>;
  denialReason?: Maybe<Scalars['String']['output']>;
  medicationBrandName?: Maybe<Scalars['String']['output']>;
  medicationGenericName?: Maybe<Scalars['String']['output']>;
  subDenialReasons: Array<SubDenialReason>;
};

export type DenialLetter = {
  __typename?: 'DenialLetter';
  confirmed?: Maybe<DenialLetterInfo>;
  extracted?: Maybe<DenialLetterInfo>;
  s3Urls: Array<Maybe<UploadUrls>>;
};

export type DenialLetterFile = {
  __typename?: 'DenialLetterFile';
  url: Scalars['String']['output'];
};

export type DenialLetterInfo = {
  __typename?: 'DenialLetterInfo';
  daysToAppeal?: Maybe<Scalars['Int']['output']>;
  denialDate?: Maybe<Scalars['Date']['output']>;
  denialReason?: Maybe<Scalars['String']['output']>;
  disease?: Maybe<Scalars['String']['output']>;
  medicationBrandName?: Maybe<Scalars['String']['output']>;
  medicationGenericName?: Maybe<Scalars['String']['output']>;
};

export enum DenyingParty {
  InsuranceCompany = 'INSURANCE_COMPANY',
  Other = 'OTHER',
  Pbm = 'PBM'
}

export type DenyingPartyAppealDepartment = {
  __typename?: 'DenyingPartyAppealDepartment';
  address: Address;
  company?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DenyingPartyInput = {
  denyingParty: DenyingParty;
  otherDenyingPartyName?: InputMaybe<Scalars['String']['input']>;
};

export type Employer = {
  __typename?: 'Employer';
  address?: Maybe<Address>;
  employerName?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
};

export type EmployerInput = {
  address: AddressInput;
  employerName: Scalars['String']['input'];
  fax?: InputMaybe<Scalars['String']['input']>;
  recipientName: Scalars['String']['input'];
};

export type EvidenceSearchTermsInput = {
  condition?: InputMaybe<Array<Scalars['String']['input']>>;
  medication?: InputMaybe<Array<Scalars['String']['input']>>;
  minNumberOfCitations?: InputMaybe<Scalars['Int']['input']>;
};

export enum FaxSentStatus {
  Initiated = 'INITIATED',
  InitiationFailed = 'INITIATION_FAILED',
  SendFailed = 'SEND_FAILED',
  SendSucceeded = 'SEND_SUCCEEDED'
}

export type GatherClinicalEvidenceInput = {
  brandName: Scalars['String']['input'];
  condition: Scalars['String']['input'];
  genericName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GatherClinicalEvidenceResult = {
  __typename?: 'GatherClinicalEvidenceResult';
  papersInserted: Scalars['Int']['output'];
};

export type HistoryQuestion = {
  __typename?: 'HistoryQuestion';
  answer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  question: Scalars['String']['output'];
};

export type InReviewClinicalEvidence = {
  __typename?: 'InReviewClinicalEvidence';
  abstract: Scalars['String']['output'];
  citation: Scalars['String']['output'];
  condition: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  medication: Scalars['String']['output'];
  numberOfCitations: Scalars['Int']['output'];
};

export type InitialReferralData = {
  __typename?: 'InitialReferralData';
  appealId: Scalars['ID']['output'];
  condition: Scalars['String']['output'];
  denialReason: Scalars['String']['output'];
  medication: Scalars['String']['output'];
};

export type InitializeReferralInput = {
  condition: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
  medication: Scalars['String']['input'];
  otherAppealSituations?: InputMaybe<Array<OtherAppealSituations>>;
  subDenialReasons?: InputMaybe<Array<SubDenialReason>>;
};

export type InitiateAppealInput = {
  appealType?: InputMaybe<AppealType>;
  bmiComorbidCriteria?: InputMaybe<Scalars['Float']['input']>;
  bmiObesityCriteria?: InputMaybe<Scalars['Float']['input']>;
  caregiver?: InputMaybe<CaregiverInput>;
  condition: Scalars['String']['input'];
  coverageFundAppeal?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth: Scalars['Date']['input'];
  denialReason: Scalars['String']['input'];
  denyingParty?: InputMaybe<DenyingParty>;
  firstName: Scalars['String']['input'];
  hasConsentedToSMSNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  medication: Scalars['String']['input'];
  otherDenyingPartyName?: InputMaybe<Scalars['String']['input']>;
  pbmName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Pronouns>;
  sex?: InputMaybe<Sex>;
  state: Scalars['String']['input'];
  subDenialReasons?: InputMaybe<Array<SubDenialReason>>;
};

export type InsuranceInfo = {
  __typename?: 'InsuranceInfo';
  confirmed?: Maybe<InsuranceInfoDetails>;
  extracted?: Maybe<InsuranceInfoDetails>;
  s3Url: Array<Maybe<UploadUrls>>;
};

export type InsuranceInfoDetails = {
  __typename?: 'InsuranceInfoDetails';
  birthDate?: Maybe<Scalars['Date']['output']>;
  claimId?: Maybe<Scalars['String']['output']>;
  denyingParty?: Maybe<DenyingParty>;
  employer?: Maybe<Scalars['String']['output']>;
  enrolleeFirstName?: Maybe<Scalars['String']['output']>;
  enrolleeLastName?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  insuranceProvider?: Maybe<Scalars['String']['output']>;
  insuranceType?: Maybe<Scalars['String']['output']>;
  isPatientEnrollee?: Maybe<Scalars['Boolean']['output']>;
  memberNumber?: Maybe<Scalars['String']['output']>;
  otherAppealSituations?: Maybe<Array<OtherAppealSituations>>;
  otherDenyingPartyName?: Maybe<Scalars['String']['output']>;
  pbmName?: Maybe<Scalars['String']['output']>;
  planCategory?: Maybe<PlanCategory>;
  rxBinNumber?: Maybe<Scalars['String']['output']>;
  rxGroupNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type LetterGeneration = {
  __typename?: 'LetterGeneration';
  appealLetterGenerationId?: Maybe<Scalars['ID']['output']>;
  createdTimestamp?: Maybe<Scalars['Date']['output']>;
  generationOutput?: Maybe<Scalars['String']['output']>;
  letterBody?: Maybe<Scalars['String']['output']>;
  letterReferences?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  updatedTimestamp?: Maybe<Scalars['Date']['output']>;
};

export type LetterOfNecessityInfo = {
  __typename?: 'LetterOfNecessityInfo';
  s3Urls: Array<Maybe<UploadUrls>>;
};

export type LetterRevisionHistory = {
  __typename?: 'LetterRevisionHistory';
  comment?: Maybe<Scalars['String']['output']>;
  createdTimestamp?: Maybe<Scalars['Date']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  supportUserEmail?: Maybe<Scalars['String']['output']>;
  supportUserId?: Maybe<Scalars['ID']['output']>;
};

export type LetterRevisionInput = {
  appealLetter: AppealLetterInput;
  comment: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type ManualAppealSendInput = {
  appealId: Scalars['ID']['input'];
  customDestination?: InputMaybe<AppealDestinationInput>;
  method: SendMethod;
  usePayerDestination: Scalars['Boolean']['input'];
};

export type ManualAppealSendResponse = {
  __typename?: 'ManualAppealSendResponse';
  error?: Maybe<Scalars['String']['output']>;
  letterSent?: Maybe<Scalars['Boolean']['output']>;
  letterTrackingId?: Maybe<Scalars['String']['output']>;
  sentFax?: Maybe<SentFax>;
  success: Scalars['Boolean']['output'];
};

export type MedicalHistory = {
  __typename?: 'MedicalHistory';
  questions: Array<HistoryQuestion>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Updates a provider user's role (Support only) */
  UpdateProviderUserRole?: Maybe<ProviderUser>;
  /**
   * Adds a new clinical evidence record directly to the gold standard table.
   * Support users only. Evidence will be immediately available for letter generation.
   */
  addClinicalEvidenceEntry: ClinicalEvidence;
  /** Creates a provider user within the same provider that the user calling is in. */
  addNewUserToProvider?: Maybe<ProviderUser>;
  /** Creates a provider user in the provided provider. */
  addNewUserToProviderByProviderId?: Maybe<ProviderUser>;
  /** Approves a payer policy extraction */
  approvePayerPolicyExtraction: PayerPolicyExtraction;
  /**
   * Archive in-review clinical evidence.
   * Evidence will no longer appear in queries but remains in database.
   * Support users only.
   */
  archiveInReviewEvidence: Scalars['Boolean']['output'];
  /** Create an exact clone of an existing appeal with all data preserved */
  cloneAppeal: Scalars['ID']['output'];
  /** This will set the closed status on an appeal */
  closeAppeal: Appeal;
  /** This will take the confirmed details and appeal id passed in and save the details as confirmed to the dynamoDB */
  confirmDetails?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Given the appealId and the input for an appealLetterIssue, this endpoint will create a HelpScout Conversation to track the issue.
   * It will also update the status for issueOutstanding to true.
   */
  createAppealLetterIssue?: Maybe<Scalars['Boolean']['output']>;
  /** Creates a checkout session for the provider when they are purchasing packs of referrals */
  createAppealPackageCheckoutSession: Scalars['String']['output'];
  /** This will initiate a checkout session in Stripe and send back the session ID for the Client to use to connect to the session */
  createCheckoutSession: Scalars['String']['output'];
  /** Allows a support user to revise a letter manually */
  createLetterRevision: Scalars['ID']['output'];
  /** Create a provider with an initial provider user, returns the new provider ID */
  createProvider?: Maybe<Scalars['ID']['output']>;
  /** Create a provider with a user for whoever created the provider, returns the new provider */
  createProviderViaSelfSignUp: Provider;
  /** Creates a new survey schema */
  createSurveySchema: SurveySchema;
  /** Creates a new version of an existing survey schema */
  createSurveySchemaVersion: SurveySchema;
  /** Deletes an appeal supporting document */
  deleteAppealSupportingDocument?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Given a number of files this will return a list of strings that will be used as the url to send
   * the files to upload for a denial letter. This will also update the DenialLetter on the Appeal to
   * have the s3Urls.
   *
   * This will also update the status of the appeal to reflect that a denial letter has been uploaded.
   * (this may change later)
   */
  denialLetterUploadLinks: Array<UploadLink>;
  /** Returns a url that can be used to upload a denial upheld letter. */
  denialUpheldLetterLinks: Array<UploadLink>;
  /** Returns links that can be used to download the pdf of the generated appeal letter */
  downloadAppealLetterLink?: Maybe<Scalars['String']['output']>;
  /** Returns links that can be used to download the baa */
  downloadBAAFormLink?: Maybe<Scalars['String']['output']>;
  /** Edits an existing unpublished survey schema in place (only allowed for unpublished schemas) */
  editSurveySchema: SurveySchema;
  /**
   * Searches Semantic Scholar for clinical evidence and stores results in the in-review table.
   * Support users only. Papers can be reviewed and promoted to gold standard evidence.
   */
  gatherClinicalEvidence: GatherClinicalEvidenceResult;
  /** This will generate the final pdf letter and then send the request to Lob to send out the letter */
  generateFinalPDF?: Maybe<Scalars['Boolean']['output']>;
  /** Initialize a new referral with minimal information for eligibility checking */
  initializeReferral: InitialReferralData;
  /** This will create the appealId and insert a row in our db */
  initiateAppeal: Scalars['ID']['output'];
  /** Inserts a user event into the user_event table */
  insertUserEvent?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This will return a string that will be used as the url to send
   * the files to upload for a denial letter. This will also update the InsuranceInfo on the Appeal to
   * have the s3Urls.
   *
   * This will also update the status of the appeal to reflect that an insurance card has been uploaded.
   * (this may change later)
   */
  insuranceCardUploadLinks: Array<UploadLink>;
  /** Mark a followup appeal as ready for review by updating required statuses - Support users only */
  markAppealReadyForReview: Appeal;
  /** Returns a url that can be used to upload a medical letter of necessity from their doctor. */
  medicalLetterOfNecessityLinks: Array<UploadLink>;
  /** Generates a watermarked preview PDF for support users to review before final generation */
  previewAppealPdf?: Maybe<Scalars['String']['output']>;
  /** Marks a survey schema version as published (unpublishes other versions for the same condition) */
  publishSurveySchema: SurveySchema;
  /** Remove appeal outcome status (Overturned or Upheld) - Support users only */
  removeAppealOutcomeStatus?: Maybe<Scalars['Boolean']['output']>;
  reportAppealOutcomeStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Request a second appeal for eligible Zepbound forced medication switch denials upheld by CVS Caremark */
  requestSecondAppeal: Scalars['Boolean']['output'];
  /** Given the appealID, this endpoint will update the issueOutstanding status to false */
  resolveIssue?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This will take in the appeal department data and appeal id and save the information to the dynamoDB
   *
   * The dynamoDB record will have the primary key of appealId and sork key of 'appeal_depatrment_data'
   */
  saveAppealDeptData?: Maybe<Scalars['Boolean']['output']>;
  /** Given the appealId and list of CcDestinationInput, this endpoint will save the ccDestinations on the metadata object */
  saveCCDestinations?: Maybe<Scalars['Boolean']['output']>;
  /** Saves caregiver data for an appeal */
  saveCaregiverData: Scalars['Boolean']['output'];
  /** Save denial upheld reason. */
  saveDenialUpheldDenialReason?: Maybe<Scalars['Boolean']['output']>;
  /** Save whether the patient has received their claims file or not. */
  saveDenialUpheldReceivedClaimsFile?: Maybe<Scalars['Boolean']['output']>;
  /** This allows for who the denial is from to be saved on the confirmed data in the insurance info db row */
  saveDenyingParty?: Maybe<Scalars['Boolean']['output']>;
  /** Save Insurance destination for Employer Self-Funded insurance */
  saveInsuranceEmployer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Save complete insurance information for an appeal including provider details,
   * plan category, policyholder relationship, denying party, and optional employer
   * and pharmacy benefit manager information. This mutation is idempotent and can
   * be called multiple times to update insurance information.
   *
   * Required fields:
   * - insuranceProvider: Name of the insurance company
   * - memberId: Insurance member/subscriber ID
   * - groupNumber: Insurance group number
   * - planCategory: Type of insurance plan
   * - denyingParty: Which party denied the claim
   * - relationshipToPolicyholder: Patient's relationship to the primary policyholder
   *
   * Conditional requirements:
   * - If relationshipToPolicyholder is SPOUSE or DEPENDENT: policyholderFirstName and policyholderLastName required
   * - If planCategory is EMPLOYER_FULLY_INSURED or EMPLOYER_SELF_FUNDED: employerName required
   */
  saveInsuranceInfo?: Maybe<Scalars['Boolean']['output']>;
  saveIsExpeditedReview?: Maybe<Scalars['Boolean']['output']>;
  /** This allows for the patient to save if there are other appeal situations in the insurance info db row */
  saveOtherAppealSituations?: Maybe<Scalars['Boolean']['output']>;
  /** Saves patient and caregiver information for a provider referral */
  savePatientAndCaregiverInfoOnReferral: Scalars['Boolean']['output'];
  /**
   * This will take in the patient data and appeal id and save the information to the dynamoDB
   *
   * The dynamoDB record will have the primary key of appealId and sork key of 'patient_data'
   */
  savePatientData?: Maybe<Scalars['Boolean']['output']>;
  /** This allows the primary enrollee of the insurance plan to be saved in the confirmed insurance data */
  savePrimaryEnrollee?: Maybe<Scalars['Boolean']['output']>;
  /** Saves default referral message for a provider */
  saveProviderDefaultReferralMessage?: Maybe<Provider>;
  /**
   * Given a ReferralInput this endpoint will do the following:
   * - create a new user in the cognito user pool if user does not already exist
   * - start a new appeal
   * - save a referral record
   * - save birthDate in confirmed insurance info
   * - save the disease, medication, and denial reason in the confirmed denial letter info
   * - save the first name, last name, and date of birth to the patient data
   * - generate links to upload files to s3
   *
   * This will return the ReferralOutput which will have the referralID and upload links
   */
  saveReferral: ReferralOutput;
  /**
   * Send an appeal manually to a specific destination.
   * Allows support users to send appeals via fax or mail to either
   * the configured payer destination or a custom address.
   */
  sendAppealManually: ManualAppealSendResponse;
  /** Send a referral to the patient via email. This finalizes the referral by sending the email and marking it as sent. */
  sendReferralToPatient: Scalars['Boolean']['output'];
  /** Assign referred appeals to the user upon account creation */
  setupNewUserWithExistingReferrals?: Maybe<Array<Appeal>>;
  /** Marks this provider as having accepted the BAA with Claimable */
  signProviderBusinessAssociateAgreement?: Maybe<Provider>;
  /** This is used to record that the user is skipping either the DENIAL_LETTER or INSURANCE_CARD uploads */
  skipUpload?: Maybe<Scalars['Boolean']['output']>;
  /** This will send an event that will start the generation process for a given appeal */
  startGenerateAppeal?: Maybe<Scalars['Boolean']['output']>;
  /** Start a new appeal based on an existing appeal with relevant data carried forward */
  startNextAppeal: Scalars['ID']['output'];
  /**
   * Submit an enterprise provider appeal without payment.
   * Only available to enterprise_provider type organizations.
   */
  submitEnterpriseAppeal: Scalars['Boolean']['output'];
  /** Toggles whether an appeal supporting document is included in the appeal letter */
  toggleAppealSupportingDocumentInclusion: AppealSupportingDocument;
  /**
   * Toggles Claimable sponsorship for an appeal.
   * If the appeal is not sponsored, it adds Claimable sponsorship.
   * If the appeal is sponsored by Claimable, it removes the sponsorship.
   * Only available to support users.
   */
  toggleClaimableAppealSponsorship: Appeal;
  /** Updates denial reason and sub-denial reasons for an existing appeal */
  updateAppealDenialReasons: Appeal;
  /** This will update the plan category of an existing appeal */
  updateAppealPlanCategory?: Maybe<Appeal>;
  /** Updates the appeal type for an existing appeal */
  updateAppealType: Scalars['Boolean']['output'];
  /** Updates a payer policy extraction's clinical criteria */
  updatePayerPolicyExtraction: PayerPolicyExtraction;
  /** Updates providers free trail end date */
  updateProviderFreeTrialEndDate?: Maybe<Provider>;
  /** Updates a provider user's active status (Admins only) */
  updateProviderUserActiveStatus: ProviderUser;
  /** Updates a provider user's personal info */
  updateProviderUserInfo?: Maybe<ProviderUser>;
  /** This allows for survey answers to be saved to an appeal via an appealId */
  updateSurveyAnswers?: Maybe<Scalars['Boolean']['output']>;
  /** This allows for survey-js answers to be saved to an appeal via an appealId */
  updateSurveyJsAnswers?: Maybe<Scalars['Boolean']['output']>;
  /** Upserts an appeal supporting document */
  upsertAppealSupportingDocument: UpsertAppealSupportingDocumentResponse;
};


export type MutationUpdateProviderUserRoleArgs = {
  providerUserId: Scalars['ID']['input'];
  role: ProviderUserRole;
};


export type MutationAddClinicalEvidenceEntryArgs = {
  input: AddClinicalEvidenceEntryInput;
};


export type MutationAddNewUserToProviderArgs = {
  email: Scalars['String']['input'];
};


export type MutationAddNewUserToProviderByProviderIdArgs = {
  email: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
  role?: InputMaybe<ProviderUserRole>;
};


export type MutationApprovePayerPolicyExtractionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveInReviewEvidenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCloneAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationCloseAppealArgs = {
  appealId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
};


export type MutationConfirmDetailsArgs = {
  appealId: Scalars['ID']['input'];
  confirmDetails: ConfirmDetailsInput;
};


export type MutationCreateAppealLetterIssueArgs = {
  appealId: Scalars['ID']['input'];
  appealLetterIssue: AppealLetterIssueInput;
};


export type MutationCreateAppealPackageCheckoutSessionArgs = {
  appealPackage: AppealPackage;
};


export type MutationCreateCheckoutSessionArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationCreateLetterRevisionArgs = {
  appealId: Scalars['ID']['input'];
  letterRevision: LetterRevisionInput;
};


export type MutationCreateProviderArgs = {
  providerName: Scalars['String']['input'];
  providerUserEmail: Scalars['String']['input'];
  type: ProviderType;
};


export type MutationCreateProviderViaSelfSignUpArgs = {
  input: CreateProviderViaSelfSignUpInput;
};


export type MutationCreateSurveySchemaArgs = {
  input: CreateSurveySchemaInput;
};


export type MutationCreateSurveySchemaVersionArgs = {
  input: UpdateSurveySchemaInput;
};


export type MutationDeleteAppealSupportingDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDenialLetterUploadLinksArgs = {
  appealId: Scalars['ID']['input'];
  fileExtensions: Array<Scalars['String']['input']>;
};


export type MutationDenialUpheldLetterLinksArgs = {
  appealId: Scalars['ID']['input'];
  fileExtensions: Array<Scalars['String']['input']>;
};


export type MutationDownloadAppealLetterLinkArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationEditSurveySchemaArgs = {
  input: UpdateSurveySchemaInput;
};


export type MutationGatherClinicalEvidenceArgs = {
  input: GatherClinicalEvidenceInput;
};


export type MutationGenerateFinalPdfArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationInitializeReferralArgs = {
  input: InitializeReferralInput;
};


export type MutationInitiateAppealArgs = {
  initiateAppealInput: InitiateAppealInput;
};


export type MutationInsertUserEventArgs = {
  appealId?: InputMaybe<Scalars['ID']['input']>;
  eventDetails?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInsuranceCardUploadLinksArgs = {
  appealId: Scalars['ID']['input'];
  fileExtensions: Array<Scalars['String']['input']>;
};


export type MutationMarkAppealReadyForReviewArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationMedicalLetterOfNecessityLinksArgs = {
  appealId: Scalars['ID']['input'];
  fileExtensions: Array<Scalars['String']['input']>;
};


export type MutationPreviewAppealPdfArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationPublishSurveySchemaArgs = {
  input: PublishSurveySchemaInput;
};


export type MutationRemoveAppealOutcomeStatusArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationReportAppealOutcomeStatusArgs = {
  appealId: Scalars['ID']['input'];
  status: ReportAppealStatusInput;
};


export type MutationRequestSecondAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationResolveIssueArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationSaveAppealDeptDataArgs = {
  appealDeptData: AppealDestinationInput;
  appealId: Scalars['ID']['input'];
};


export type MutationSaveCcDestinationsArgs = {
  appealId: Scalars['ID']['input'];
  destinations: Array<CcDestinationInput>;
};


export type MutationSaveCaregiverDataArgs = {
  appealId: Scalars['ID']['input'];
  caregiver: CaregiverInput;
};


export type MutationSaveDenialUpheldDenialReasonArgs = {
  appealId: Scalars['ID']['input'];
  denialReason: Scalars['String']['input'];
};


export type MutationSaveDenialUpheldReceivedClaimsFileArgs = {
  appealId: Scalars['ID']['input'];
  hasReceivedClaimsFile: Scalars['Boolean']['input'];
};


export type MutationSaveDenyingPartyArgs = {
  appealId: Scalars['ID']['input'];
  denyingParty: DenyingPartyInput;
};


export type MutationSaveInsuranceEmployerArgs = {
  appealId: Scalars['ID']['input'];
  employer: EmployerInput;
};


export type MutationSaveInsuranceInfoArgs = {
  appealId: Scalars['ID']['input'];
  insuranceInfo: SaveInsuranceInfoInput;
};


export type MutationSaveIsExpeditedReviewArgs = {
  appealId: Scalars['ID']['input'];
  isExpeditedReview: Scalars['Boolean']['input'];
};


export type MutationSaveOtherAppealSituationsArgs = {
  appealId: Scalars['ID']['input'];
  otherAppealSituations: OtherAppealSituationsInput;
};


export type MutationSavePatientAndCaregiverInfoOnReferralArgs = {
  input: SavePatientAndCaregiverInfoOnReferralInput;
};


export type MutationSavePatientDataArgs = {
  appealId: Scalars['ID']['input'];
  patientData: PatientDataInput;
};


export type MutationSavePrimaryEnrolleeArgs = {
  appealId: Scalars['ID']['input'];
  primaryEnrollee: PrimaryEnrolleeInput;
};


export type MutationSaveProviderDefaultReferralMessageArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
};


export type MutationSaveReferralArgs = {
  referral: ReferralInput;
};


export type MutationSendAppealManuallyArgs = {
  input: ManualAppealSendInput;
};


export type MutationSendReferralToPatientArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationSetupNewUserWithExistingReferralsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationSkipUploadArgs = {
  appealId: Scalars['ID']['input'];
  uploadSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  uploadType: UploadDocumentType;
};


export type MutationStartGenerateAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationStartNextAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationSubmitEnterpriseAppealArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationToggleAppealSupportingDocumentInclusionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationToggleClaimableAppealSponsorshipArgs = {
  appealId: Scalars['ID']['input'];
};


export type MutationUpdateAppealDenialReasonsArgs = {
  input: UpdateAppealDenialReasonsInput;
};


export type MutationUpdateAppealPlanCategoryArgs = {
  appealId: Scalars['ID']['input'];
  updateAppealPlanCategoryInput: UpdateAppealPlanCategoryInput;
};


export type MutationUpdateAppealTypeArgs = {
  appealId: Scalars['ID']['input'];
  appealType: AppealType;
};


export type MutationUpdatePayerPolicyExtractionArgs = {
  continuationClinicalCriteria?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  initialClinicalCriteria: Scalars['String']['input'];
};


export type MutationUpdateProviderFreeTrialEndDateArgs = {
  newEndDate: Scalars['Date']['input'];
  providerId: Scalars['ID']['input'];
};


export type MutationUpdateProviderUserActiveStatusArgs = {
  active: Scalars['Boolean']['input'];
  providerUserId: Scalars['ID']['input'];
};


export type MutationUpdateProviderUserInfoArgs = {
  input: UpdateProviderUserInfoInput;
};


export type MutationUpdateSurveyAnswersArgs = {
  appealId: Scalars['ID']['input'];
  surveyAnswers: Array<SurveyAnswerInput>;
};


export type MutationUpdateSurveyJsAnswersArgs = {
  appealId: Scalars['ID']['input'];
  surveyJsAnswers: Scalars['String']['input'];
  surveySchemaId: Scalars['ID']['input'];
};


export type MutationUpsertAppealSupportingDocumentArgs = {
  appealId: Scalars['ID']['input'];
  document: UpsertAppealSupportingDocumentInput;
};

export enum OrganizationType {
  AdvocacyGroup = 'ADVOCACY_GROUP',
  Provider = 'PROVIDER'
}

export enum OtherAppealSituations {
  AppealPeriodExpired = 'APPEAL_PERIOD_EXPIRED',
  CopayDoesNotCount = 'COPAY_DOES_NOT_COUNT',
  ExtremeCareDelay = 'EXTREME_CARE_DELAY',
  SwitchedHealthPlans = 'SWITCHED_HEALTH_PLANS'
}

export type OtherAppealSituationsInput = {
  otherAppealSituations: Array<OtherAppealSituations>;
};

export type PaginatedAppeals = {
  __typename?: 'PaginatedAppeals';
  data: Array<Appeal>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedClinicalEvidence = {
  __typename?: 'PaginatedClinicalEvidence';
  data: Array<ClinicalEvidence>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedInReviewClinicalEvidence = {
  __typename?: 'PaginatedInReviewClinicalEvidence';
  data: Array<InReviewClinicalEvidence>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPayerPolicyClinicalCriteria = {
  __typename?: 'PaginatedPayerPolicyClinicalCriteria';
  data: Array<PayerPolicyClinicalCriteria>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPayerPolicyExtraction = {
  __typename?: 'PaginatedPayerPolicyExtraction';
  data: Array<PayerPolicyExtraction>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedProviders = {
  __typename?: 'PaginatedProviders';
  data: Array<Provider>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedReferrals = {
  __typename?: 'PaginatedReferrals';
  referrals: Array<Referral>;
  totalCount: Scalars['Int']['output'];
};

export type Patient = {
  __typename?: 'Patient';
  address?: Maybe<Address>;
  dateOfBirth: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Pronouns>;
  sex?: Maybe<Sex>;
};

export type PatientDataInput = {
  address: AddressInput;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Pronouns>;
  sex?: InputMaybe<Sex>;
};

export type PatientInfoInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pronouns?: InputMaybe<Pronouns>;
  sex?: InputMaybe<Sex>;
  state: Scalars['String']['input'];
};

export type PatientInsurance = {
  __typename?: 'PatientInsurance';
  denyingParty?: Maybe<DenyingParty>;
  employer?: Maybe<Employer>;
  enrolleeFirstName?: Maybe<Scalars['String']['output']>;
  enrolleeLastName?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  insuranceType?: Maybe<Scalars['String']['output']>;
  isPatientEnrollee?: Maybe<Scalars['Boolean']['output']>;
  memberNumber?: Maybe<Scalars['String']['output']>;
  otherAppealSituations?: Maybe<Array<OtherAppealSituations>>;
  otherDenyingPartyName?: Maybe<Scalars['String']['output']>;
  pbmName?: Maybe<Scalars['String']['output']>;
  planCategory?: Maybe<PlanCategory>;
  providerName?: Maybe<Scalars['String']['output']>;
  rxBinNumber?: Maybe<Scalars['String']['output']>;
  rxGroupNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type PayerPolicyClinicalCriteria = {
  __typename?: 'PayerPolicyClinicalCriteria';
  condition: Scalars['String']['output'];
  continuationClinicalCriteria: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initialClinicalCriteria: Scalars['String']['output'];
  medication: Scalars['String']['output'];
  payer: Scalars['String']['output'];
};

export type PayerPolicyClinicalCriteriaInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<PayerPolicyClinicalCriteriaSearchTermsInput>;
};

export type PayerPolicyClinicalCriteriaSearchTermsInput = {
  condition?: InputMaybe<Array<Scalars['String']['input']>>;
  medication?: InputMaybe<Array<Scalars['String']['input']>>;
  payer?: InputMaybe<Scalars['String']['input']>;
};

export type PayerPolicyExtraction = {
  __typename?: 'PayerPolicyExtraction';
  approvingUserId?: Maybe<Scalars['ID']['output']>;
  condition: Scalars['String']['output'];
  continuationClinicalCriteria?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initialClinicalCriteria: Scalars['String']['output'];
  medication: Scalars['String']['output'];
  payer: Scalars['String']['output'];
  payerPolicyClinicalCriteriaId?: Maybe<Scalars['ID']['output']>;
  policyBotId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PayerPolicyExtractionInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<PayerPolicyExtractionSearchTermsInput>;
};

export type PayerPolicyExtractionSearchTermsInput = {
  approvalStatus?: InputMaybe<ApprovalStatus>;
  condition?: InputMaybe<Array<Scalars['String']['input']>>;
  medication?: InputMaybe<Array<Scalars['String']['input']>>;
  payer?: InputMaybe<Scalars['String']['input']>;
};

export type Payment = {
  __typename?: 'Payment';
  amountDiscount: Scalars['Float']['output'];
  amountSubtotal: Scalars['Float']['output'];
  amountTax: Scalars['Float']['output'];
  amountTotal: Scalars['Float']['output'];
  appealPrice: Scalars['Float']['output'];
  checkoutSessionId: Scalars['String']['output'];
  destinationPrice: Scalars['Float']['output'];
  destinationQuantity: Scalars['Int']['output'];
  paymentIntentId: Scalars['String']['output'];
  paymentMethodType: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  paymentTimestamp: Scalars['Date']['output'];
  shippingAmount: Scalars['Float']['output'];
};

export enum PlanCategory {
  EmployerFederalGovernment = 'EMPLOYER_FEDERAL_GOVERNMENT',
  EmployerFullyInsured = 'EMPLOYER_FULLY_INSURED',
  EmployerLocalStateGovernment = 'EMPLOYER_LOCAL_STATE_GOVERNMENT',
  EmployerSelfFunded = 'EMPLOYER_SELF_FUNDED',
  IndividualExchange = 'INDIVIDUAL_EXCHANGE',
  Medicaid = 'MEDICAID',
  MedicareAdvantage = 'MEDICARE_ADVANTAGE',
  MedicareTraditional = 'MEDICARE_TRADITIONAL'
}

export type PrimaryEnrolleeInput = {
  enrolleeFirstName?: InputMaybe<Scalars['String']['input']>;
  enrolleeLastName?: InputMaybe<Scalars['String']['input']>;
  isPatientEnrollee: Scalars['Boolean']['input'];
};

export type ProductPrices = {
  __typename?: 'ProductPrices';
  appealPrice: Scalars['Float']['output'];
  ccDestinationPrice: Scalars['Float']['output'];
  shippingRate: Scalars['Float']['output'];
};

export enum Pronouns {
  HeHimHis = 'HE_HIM_HIS',
  SheHerHers = 'SHE_HER_HERS',
  TheyThemTheirs = 'THEY_THEM_THEIRS'
}

export type Provider = {
  __typename?: 'Provider';
  createdTimestamp: Scalars['Date']['output'];
  defaultReferralMessage?: Maybe<Scalars['String']['output']>;
  facilities: Array<ProviderFacility>;
  freeTrialEndTimestamp: Scalars['String']['output'];
  hasSignedBAA: Scalars['Boolean']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<OrganizationType>;
  providerId: Scalars['ID']['output'];
  providerName: Scalars['String']['output'];
  purchases?: Maybe<Array<Purchase>>;
  specialty?: Maybe<Scalars['String']['output']>;
  sponsoredAppeals?: Maybe<SponsoredAppeals>;
  type: ProviderType;
  users: Array<ProviderUser>;
};

export type ProviderCheckoutSessionStatus = {
  __typename?: 'ProviderCheckoutSessionStatus';
  complete: Scalars['Boolean']['output'];
};

export type ProviderFacility = {
  __typename?: 'ProviderFacility';
  facilityName: Scalars['String']['output'];
  facilityShortName: Scalars['String']['output'];
  providerFacilityId: Scalars['ID']['output'];
};

export type ProviderReferral = {
  __typename?: 'ProviderReferral';
  appealId: Scalars['ID']['output'];
  createdTimestamp: Scalars['Date']['output'];
  hasPatientConsent?: Maybe<Scalars['Boolean']['output']>;
  providerMessage?: Maybe<Scalars['String']['output']>;
  providerUserId: Scalars['ID']['output'];
  referralId: Scalars['ID']['output'];
};

export enum ProviderType {
  EnterpriseProvider = 'enterprise_provider',
  Provider = 'provider'
}

export type ProviderUser = {
  __typename?: 'ProviderUser';
  active: Scalars['Boolean']['output'];
  createdTimestamp: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['ID']['output'];
  providerUserId: Scalars['ID']['output'];
  role: ProviderUserRole;
};

export enum ProviderUserRole {
  Admin = 'ADMIN',
  User = 'USER'
}

export type ProvidersInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<ProvidersSearchTermsInput>;
};

export type ProvidersSearchTermsInput = {
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  providerUserEmail?: InputMaybe<Scalars['String']['input']>;
};

export type PublishSurveySchemaInput = {
  id: Scalars['ID']['input'];
};

export type Purchase = {
  __typename?: 'Purchase';
  amountSubtotal: Scalars['Float']['output'];
  amountTax: Scalars['Float']['output'];
  amountTotal: Scalars['Float']['output'];
  appealPackageName: Scalars['String']['output'];
  appealQuantity: Scalars['Int']['output'];
  cardNumber?: Maybe<Scalars['String']['output']>;
  paymentTimestamp?: Maybe<Scalars['Date']['output']>;
  providerUserId: Scalars['ID']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Gets the addresses for the CC selection page by plan category, i.e. Self-Insured or Medicare Advantage */
  appealDestinations: Array<AppealDestination>;
  /** This will get a list of paginated appeals, sorted by created date */
  appeals: PaginatedAppeals;
  /** Gets a list of paginated clinical evidence, sorted by medication and condition. */
  clinicalEvidence: PaginatedClinicalEvidence;
  /** Gets all distinct tags used in clinical evidence for autocomplete. */
  clinicalEvidenceTags: Array<Scalars['String']['output']>;
  /**
   * Gets the appeal department for the denying party, if available, in order to default it on the appeal department page
   * - This will be determined based on the denying party (insurance, PBM, or other) and potentially the plan category depending on the insurer
   * - The fax number may also be different based on standard vs expedited review, depending on the insurer
   */
  denyingPartyAppealDepartment?: Maybe<DenyingPartyAppealDepartment>;
  /** Gets existing denial letter files for an appeal */
  existingDenialLetterFiles: Array<DenialLetterFile>;
  /** Returns all survey schemas */
  getAllSurveySchemas: Array<SurveySchema>;
  /** This will return a single appeal if the appeal id exists. It will return an empty object if the appeal does not exist. */
  getAppealById?: Maybe<Appeal>;
  /** Gets the payment information from Stripe and returns the data to the user */
  getAppealPayment?: Maybe<Payment>;
  /** This will pull the userId out of the context */
  getAppeals: Array<Appeal>;
  /** Returns all letter generations for a given appeal */
  getLetterGenerations?: Maybe<Array<Maybe<LetterGeneration>>>;
  /** Returns the letter revision for a given appeal */
  getLetterRevisions?: Maybe<Array<Maybe<LetterRevisionHistory>>>;
  /** Gets a presigned URL for a payer policy PDF from PolicyBot. */
  getPayerPolicyPresignedUrl: Scalars['String']['output'];
  /** Gets the provider based on a provider ID */
  getProviderById?: Maybe<Provider>;
  /** Returns the provider user who referred the appeal */
  getReferringProviderUser?: Maybe<ProviderUser>;
  /** Returns a survey schema by ID */
  getSurveySchemaById?: Maybe<SurveySchema>;
  /** Health check endpoint for uptime monitoring */
  healthCheck: Scalars['String']['output'];
  /** Gets a list of paginated in-review clinical evidence (pending review), sorted by medication and condition. */
  inReviewClinicalEvidence: PaginatedInReviewClinicalEvidence;
  /** Gets a list of paginated payer policy clinical criteria, sorted by payer, medication, then condition. */
  payerPolicyClinicalCriteria: PaginatedPayerPolicyClinicalCriteria;
  /** Gets a single payer policy extraction by ID. */
  payerPolicyExtraction?: Maybe<PayerPolicyExtraction>;
  /** Gets all unique payer names from payer policy extractions. */
  payerPolicyExtractionPayerNames: Array<Scalars['String']['output']>;
  /** Gets a list of paginated payer policy extractions. */
  payerPolicyExtractions: PaginatedPayerPolicyExtraction;
  /** Gets all unique payer names from payer policy clinical criteria. */
  payerPolicyPayerNames: Array<Scalars['String']['output']>;
  /** Gets the stripe prices for the appeal-letter and cc destination products */
  productPrices: ProductPrices;
  /** Gets the provider information for a provider user's provider. */
  provider?: Maybe<Provider>;
  /** Gets the status of a stripe checkout session. Used to inform the frontend that we're done updating metadata in the hook. */
  providerCheckoutSessionStatus?: Maybe<ProviderCheckoutSessionStatus>;
  /** Gets the provider information for a provider user's provider. */
  providerUser?: Maybe<ProviderUser>;
  /** Gets a list of paginated providers, sorted alphabetically by provider name. */
  providers: PaginatedProviders;
  /** Returns the published survey schema for a specific condition */
  publishedSurveySchema?: Maybe<SurveySchema>;
  /** Gets a paginated list of referrals for a provider user's provider */
  referrals: PaginatedReferrals;
  /** This will return the extracted information and confirmed info from the denial letter and the insurance card of an appeal */
  uploadInfo: UploadInfo;
};


export type QueryAppealDestinationsArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryAppealsArgs = {
  options?: InputMaybe<AppealsInput>;
};


export type QueryClinicalEvidenceArgs = {
  options?: InputMaybe<ClinicalEvidenceQueryInput>;
};


export type QueryDenyingPartyAppealDepartmentArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryExistingDenialLetterFilesArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetAppealByIdArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetAppealPaymentArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetLetterGenerationsArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetLetterRevisionsArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetPayerPolicyPresignedUrlArgs = {
  policyBotId: Scalars['ID']['input'];
};


export type QueryGetProviderByIdArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryGetReferringProviderUserArgs = {
  appealId: Scalars['ID']['input'];
};


export type QueryGetSurveySchemaByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInReviewClinicalEvidenceArgs = {
  options?: InputMaybe<ClinicalEvidenceQueryInput>;
};


export type QueryPayerPolicyClinicalCriteriaArgs = {
  options?: InputMaybe<PayerPolicyClinicalCriteriaInput>;
};


export type QueryPayerPolicyExtractionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayerPolicyExtractionsArgs = {
  options?: InputMaybe<PayerPolicyExtractionInput>;
};


export type QueryProviderCheckoutSessionStatusArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryProvidersArgs = {
  options?: InputMaybe<ProvidersInput>;
};


export type QueryPublishedSurveySchemaArgs = {
  condition: Scalars['String']['input'];
};


export type QueryReferralsArgs = {
  filter?: InputMaybe<ReferralsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUploadInfoArgs = {
  appealId: Scalars['ID']['input'];
};

export enum RecipientType {
  Ag = 'AG',
  AppealDept = 'APPEAL_DEPT',
  Cfpb = 'CFPB',
  Cms = 'CMS',
  Doi = 'DOI',
  Dol = 'DOL',
  Employer = 'EMPLOYER',
  Ftc = 'FTC',
  Gov = 'GOV',
  Hhs = 'HHS',
  Insurer = 'INSURER',
  Opm = 'OPM',
  Politician = 'POLITICIAN',
  StateHhs = 'STATE_HHS',
  UserGenerated = 'USER_GENERATED'
}

export type Referral = {
  __typename?: 'Referral';
  appeal: Appeal;
  patientEmail?: Maybe<Scalars['String']['output']>;
  referralId: Scalars['ID']['output'];
  referringUser?: Maybe<ProviderUser>;
};

export type ReferralInput = {
  condition: Scalars['String']['input'];
  dateOfBirth: Scalars['Date']['input'];
  denialLetterExtensions?: InputMaybe<Array<Scalars['String']['input']>>;
  denialReason: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  hasConsentedToSMSNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  medLetterExtensions?: InputMaybe<Array<Scalars['String']['input']>>;
  medication: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  patientEmail: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerFacilityId?: InputMaybe<Scalars['ID']['input']>;
  state: Scalars['String']['input'];
  subDenialReason?: InputMaybe<SubDenialReason>;
};

export type ReferralOutput = {
  __typename?: 'ReferralOutput';
  appealId: Scalars['String']['output'];
  denialLetterLinks?: Maybe<Array<UploadLink>>;
  medLetterLinks?: Maybe<Array<UploadLink>>;
  referralId: Scalars['String']['output'];
};

export type ReferralsFilterInput = {
  patientDateOfBirth?: InputMaybe<Scalars['String']['input']>;
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
  referringUser?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<ReferredAppealStatus>>;
};

export enum ReferredAppealStatus {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  InSupport = 'IN_SUPPORT',
  NotApproved = 'NOT_APPROVED',
  ReferralInProgress = 'REFERRAL_IN_PROGRESS',
  Referred = 'REFERRED',
  Submitted = 'SUBMITTED'
}

export enum RelationshipToPolicyholder {
  Dependent = 'DEPENDENT',
  Self = 'SELF',
  Spouse = 'SPOUSE'
}

export type ReportAppealStatusInput = {
  denialOverturned?: InputMaybe<Scalars['Boolean']['input']>;
  denialUpheld?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveInsuranceInfoInput = {
  denyingParty?: InputMaybe<DenyingParty>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceProvider?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  otherDenyingPartyName?: InputMaybe<Scalars['String']['input']>;
  pharmacyBenefitManager?: InputMaybe<Scalars['String']['input']>;
  planCategory?: InputMaybe<PlanCategory>;
  policyholderFirstName?: InputMaybe<Scalars['String']['input']>;
  policyholderLastName?: InputMaybe<Scalars['String']['input']>;
  relationshipToPolicyholder?: InputMaybe<RelationshipToPolicyholder>;
  rxBin?: InputMaybe<Scalars['String']['input']>;
  rxGroup?: InputMaybe<Scalars['String']['input']>;
};

export type SavePatientAndCaregiverInfoOnReferralInput = {
  appealId: Scalars['ID']['input'];
  caregiver?: InputMaybe<CaregiverInfoInput>;
  consentToSms?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  hasPatientConsent?: InputMaybe<Scalars['Boolean']['input']>;
  patient: PatientInfoInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerMessage?: InputMaybe<Scalars['String']['input']>;
};

export enum SendMethod {
  Fax = 'FAX',
  Mail = 'MAIL'
}

export type SentFax = {
  __typename?: 'SentFax';
  completedTimestamp?: Maybe<Scalars['Date']['output']>;
  errorDetails?: Maybe<Scalars['String']['output']>;
  faxId: Scalars['ID']['output'];
  faxNumber: Scalars['String']['output'];
  initiatedTimestamp?: Maybe<Scalars['Date']['output']>;
  sentStatus: FaxSentStatus;
};

export type SentLetter = {
  __typename?: 'SentLetter';
  address: Address;
  currentExpectedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  initiatedTimestamp: Scalars['Date']['output'];
  letterId: Scalars['ID']['output'];
  lobStatus: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export enum Sex {
  DeclineToAnswer = 'DECLINE_TO_ANSWER',
  Female = 'FEMALE',
  Male = 'MALE'
}

export type SponsoredAppeals = {
  __typename?: 'SponsoredAppeals';
  totalRemaining: Scalars['Int']['output'];
};

export enum SponsoringParty {
  Claimable = 'CLAIMABLE',
  Provider = 'PROVIDER'
}

export enum SubDenialReason {
  A1CDoesntMeetCriteria = 'A1C_DOESNT_MEET_CRITERIA',
  BmiDoesntMeetCriteria = 'BMI_DOESNT_MEET_CRITERIA',
  BowelBiopsyNotPerformed = 'BOWEL_BIOPSY_NOT_PERFORMED',
  DidntLoseEnoughWeight = 'DIDNT_LOSE_ENOUGH_WEIGHT',
  ExerciseOrDietDoesntMeetCriteria = 'EXERCISE_OR_DIET_DOESNT_MEET_CRITERIA',
  GeneticTestingRequired = 'GENETIC_TESTING_REQUIRED',
  LostTooMuchWeight = 'LOST_TOO_MUCH_WEIGHT',
  MedicationNotConsideredEffective = 'MEDICATION_NOT_CONSIDERED_EFFECTIVE',
  MedicationNotCoveredAtAll = 'MEDICATION_NOT_COVERED_AT_ALL',
  MedicationNotCoveredForMyDiagnosis = 'MEDICATION_NOT_COVERED_FOR_MY_DIAGNOSIS',
  MustTryOtherMedicationsFirst = 'MUST_TRY_OTHER_MEDICATIONS_FIRST',
  PositiveSucraidResponseContinuation = 'POSITIVE_SUCRAID_RESPONSE_CONTINUATION',
  SucraseActivityLessThan_10 = 'SUCRASE_ACTIVITY_LESS_THAN_10',
  WeightLossCareNotCoveredAtAll = 'WEIGHT_LOSS_CARE_NOT_COVERED_AT_ALL',
  WeightLossProgramDoesntMeetCriteria = 'WEIGHT_LOSS_PROGRAM_DOESNT_MEET_CRITERIA'
}

export type Survey = {
  __typename?: 'Survey';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  surveyData: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
};

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  id: Scalars['ID']['output'];
  questionText?: Maybe<Scalars['String']['output']>;
  value: Scalars['StringOrStringArray']['output'];
};

export type SurveyAnswerInput = {
  id: Scalars['ID']['input'];
  questionText?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['StringOrStringArray']['input'];
};

export type SurveySchema = {
  __typename?: 'SurveySchema';
  condition: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  schemaData: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
};

export type UpdateAppealDenialReasonsInput = {
  appealId: Scalars['ID']['input'];
  bmiComorbidCriteria?: InputMaybe<Scalars['Float']['input']>;
  bmiObesityCriteria?: InputMaybe<Scalars['Float']['input']>;
  denialReason: Scalars['String']['input'];
  subDenialReasons: Array<SubDenialReason>;
};

export type UpdateAppealPlanCategoryInput = {
  employer?: InputMaybe<EmployerInput>;
  planCategory: PlanCategory;
};

export type UpdateProviderUserInfoInput = {
  firstName: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type UpdateSurveySchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  schemaData?: InputMaybe<Scalars['String']['input']>;
};

export enum UploadDocumentType {
  DenialLetter = 'DENIAL_LETTER',
  InsuranceCard = 'INSURANCE_CARD'
}

export type UploadInfo = {
  __typename?: 'UploadInfo';
  appealId: Scalars['ID']['output'];
  denialLetterInfo?: Maybe<DenialLetter>;
  insuranceInfo?: Maybe<InsuranceInfo>;
};

export type UploadLink = {
  __typename?: 'UploadLink';
  fileExtension: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UploadUrls = {
  __typename?: 'UploadUrls';
  allFilesUploaded: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  s3Urls: Array<Scalars['String']['output']>;
};

export type UpsertAppealSupportingDocumentInput = {
  documentId?: InputMaybe<Scalars['ID']['input']>;
  documentType: AppealSupportingDocumentType;
  files: Array<AppealSupportingDocumentFileInput>;
  otherDocumentTypeName?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertAppealSupportingDocumentResponse = {
  __typename?: 'UpsertAppealSupportingDocumentResponse';
  document: AppealSupportingDocument;
  uploadUrls: Array<Scalars['String']['output']>;
};

export type ReportAppealStatusMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  status: ReportAppealStatusInput;
}>;


export type ReportAppealStatusMutation = { __typename?: 'Mutation', reportAppealOutcomeStatus?: boolean | null };

export type GetAppealInsuranceQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealInsuranceQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', patientInsurance?: { __typename?: 'PatientInsurance', providerName?: string | null, planCategory?: PlanCategory | null, memberNumber?: string | null, groupNumber?: string | null, rxGroupNumber?: string | null, rxBinNumber?: string | null, pbmName?: string | null, isPatientEnrollee?: boolean | null, enrolleeFirstName?: string | null, enrolleeLastName?: string | null, denyingParty?: DenyingParty | null, otherDenyingPartyName?: string | null, employer?: { __typename?: 'Employer', employerName?: string | null } | null } | null, denial?: { __typename?: 'Denial', denialReason?: string | null, subDenialReasons: Array<SubDenialReason> } | null } | null };

export type SaveInsuranceInfoMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  insuranceInfo: SaveInsuranceInfoInput;
}>;


export type SaveInsuranceInfoMutation = { __typename?: 'Mutation', saveInsuranceInfo?: boolean | null };

export type GetProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProviderQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, hasSignedBAA: boolean, providerName: string } | null };

export type GetProviderForPatientFormQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProviderForPatientFormQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, hasSignedBAA: boolean } | null };

export type GetAppealByIdForPatientFormQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealByIdForPatientFormQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, referringProviderName?: string | null, referralPatientEmail?: string | null, patient?: { __typename?: 'Patient', firstName: string, lastName: string, dateOfBirth: any, sex?: Sex | null, pronouns?: Pronouns | null, phone?: string | null, address?: { __typename?: 'Address', state: string } | null } | null, caregiver?: { __typename?: 'Caregiver', firstName: string, lastName: string, dateOfBirth: any, relationship: CaregiverRelationship } | null, referral?: { __typename?: 'ProviderReferral', providerMessage?: string | null, hasPatientConsent?: boolean | null } | null, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null, denialReason?: string | null } | null, supportingDocuments?: Array<{ __typename?: 'AppealSupportingDocument', documentId: string, documentType: AppealSupportingDocumentType, files: Array<{ __typename?: 'AppealSupportingDocumentFile', fileId: string, fileName: string, fileType: AppealSupportingDocumentFileType, url: string }> }> | null } | null };

export type SavePatientAndCaregiverInfoOnReferralFromFormMutationVariables = Exact<{
  input: SavePatientAndCaregiverInfoOnReferralInput;
}>;


export type SavePatientAndCaregiverInfoOnReferralFromFormMutation = { __typename?: 'Mutation', savePatientAndCaregiverInfoOnReferral: boolean };

export type UpsertConsentDocumentFromFormMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: UpsertAppealSupportingDocumentInput;
}>;


export type UpsertConsentDocumentFromFormMutation = { __typename?: 'Mutation', upsertAppealSupportingDocument: { __typename?: 'UpsertAppealSupportingDocumentResponse', uploadUrls: Array<string> } };

export type ProviderAndUserForDefaultMessageQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderAndUserForDefaultMessageQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, providerName: string, defaultReferralMessage?: string | null } | null, providerUser?: { __typename?: 'ProviderUser', role: ProviderUserRole } | null };

export type SaveProviderDefaultReferralMessageMutationVariables = Exact<{
  providerId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveProviderDefaultReferralMessageMutation = { __typename?: 'Mutation', saveProviderDefaultReferralMessage?: { __typename?: 'Provider', providerId: string, defaultReferralMessage?: string | null } | null };

export type GetAppealForProgressTrackerQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealForProgressTrackerQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, patient?: { __typename?: 'Patient', firstName: string, lastName: string, dateOfBirth: any } | null, status: { __typename?: 'AppealStatus', referred?: boolean | null } } | null };

export type SendReferralToPatientMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type SendReferralToPatientMutation = { __typename?: 'Mutation', sendReferralToPatient: boolean };

export type DownloadAppealLetterLinkMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type DownloadAppealLetterLinkMutation = { __typename?: 'Mutation', downloadAppealLetterLink?: string | null };

export type GetSupportingDocumentsForAppealQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetSupportingDocumentsForAppealQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', referralPatientEmail?: string | null, supportingDocuments?: Array<{ __typename?: 'AppealSupportingDocument', documentId: string, documentType: AppealSupportingDocumentType, uploadedBy: AppealSupportingDocumentUploadedBy, otherDocumentTypeName?: string | null, files: Array<{ __typename?: 'AppealSupportingDocumentFile', fileId: string, fileName: string, fileType: AppealSupportingDocumentFileType, url: string }> }> | null, patient?: { __typename?: 'Patient', firstName: string, lastName: string, dateOfBirth: any } | null, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null } | null } | null };

export type UpsertAppealSupportingDocumentMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  document: UpsertAppealSupportingDocumentInput;
}>;


export type UpsertAppealSupportingDocumentMutation = { __typename?: 'Mutation', upsertAppealSupportingDocument: { __typename?: 'UpsertAppealSupportingDocumentResponse', uploadUrls: Array<string>, document: { __typename?: 'AppealSupportingDocument', documentId: string, documentType: AppealSupportingDocumentType, uploadedBy: AppealSupportingDocumentUploadedBy, otherDocumentTypeName?: string | null, files: Array<{ __typename?: 'AppealSupportingDocumentFile', fileId: string, fileName: string, fileType: AppealSupportingDocumentFileType, url: string }> } } };

export type DeleteAppealSupportingDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DeleteAppealSupportingDocumentMutation = { __typename?: 'Mutation', deleteAppealSupportingDocument?: boolean | null };

export type CreateProviderMutationVariables = Exact<{
  input: CreateProviderViaSelfSignUpInput;
}>;


export type CreateProviderMutation = { __typename?: 'Mutation', createProviderViaSelfSignUp: { __typename?: 'Provider', providerId: string, hasSignedBAA: boolean } };

export type UpdateProviderUserInfoMutationVariables = Exact<{
  input: UpdateProviderUserInfoInput;
}>;


export type UpdateProviderUserInfoMutation = { __typename?: 'Mutation', updateProviderUserInfo?: { __typename?: 'ProviderUser', providerUserId: string } | null };

export type SignBaaMutationVariables = Exact<{ [key: string]: never; }>;


export type SignBaaMutation = { __typename?: 'Mutation', signProviderBusinessAssociateAgreement?: { __typename?: 'Provider', providerId: string, hasSignedBAA: boolean } | null };

export type ProviderQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderQueryQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, hasSignedBAA: boolean, type: ProviderType } | null };

export type ProviderUserQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderUserQueryQuery = { __typename?: 'Query', providerUser?: { __typename?: 'ProviderUser', providerUserId: string, firstName?: string | null, lastName?: string | null, jobTitle?: string | null } | null };

export type DownloadBaaFormLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type DownloadBaaFormLinkMutation = { __typename?: 'Mutation', downloadBAAFormLink?: string | null };

export type ProviderPurchaseInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderPurchaseInfoQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, providerName: string, freeTrialEndTimestamp: string, createdTimestamp: any, users: Array<{ __typename?: 'ProviderUser', providerUserId: string, email: string, createdTimestamp: any, firstName?: string | null, lastName?: string | null, jobTitle?: string | null }>, sponsoredAppeals?: { __typename?: 'SponsoredAppeals', totalRemaining: number } | null, purchases?: Array<{ __typename?: 'Purchase', appealQuantity: number }> | null } | null };

export type ProviderReferralsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ReferralsFilterInput>;
}>;


export type ProviderReferralsQuery = { __typename?: 'Query', referrals: { __typename?: 'PaginatedReferrals', totalCount: number, referrals: Array<{ __typename?: 'Referral', referralId: string, patientEmail?: string | null, referringUser?: { __typename?: 'ProviderUser', providerUserId: string, firstName?: string | null, lastName?: string | null, email: string } | null, appeal: { __typename?: 'Appeal', appealId: string, referringProviderName?: string | null, createdTimestamp: any, updatedTimestamp: any, sponsoringParty?: SponsoringParty | null, sponsorshipExpiredTimestamp?: any | null, referringFacilityName?: string | null, status: { __typename?: 'AppealStatus', referred?: boolean | null, insuranceCardUpload?: boolean | null, insuranceCardUploadSkipped?: boolean | null, paymentSuccessful?: boolean | null, issueOutstanding?: boolean | null, denialUpheld?: boolean | null, denialOverturned?: boolean | null, appealSubmitted?: boolean | null }, patient?: { __typename?: 'Patient', firstName: string, lastName: string, dateOfBirth: any } | null } }> }, provider?: { __typename?: 'Provider', facilities: Array<{ __typename?: 'ProviderFacility', providerFacilityId: string }> } | null };

export type GetProviderForSucraidQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProviderForSucraidQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, providerName: string } | null };

export type ProviderTypeHookQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderTypeHookQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, type: ProviderType } | null };

export type ProviderWithFacilitiesHookQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderWithFacilitiesHookQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, facilities: Array<{ __typename?: 'ProviderFacility', providerFacilityId: string }> } | null };

export type GetPublishedSurveySchemaQueryVariables = Exact<{
  condition: Scalars['String']['input'];
}>;


export type GetPublishedSurveySchemaQuery = { __typename?: 'Query', publishedSurveySchema?: { __typename?: 'SurveySchema', id: string, condition: string, version: number, schemaData: string, description?: string | null, isPublished: boolean } | null };

export type GetAppealStatusForDocumentsQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealStatusForDocumentsQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, status: { __typename?: 'AppealStatus', referred?: boolean | null } } | null };

export type InitializeReferralMutationVariables = Exact<{
  input: InitializeReferralInput;
}>;


export type InitializeReferralMutation = { __typename?: 'Mutation', initializeReferral: { __typename?: 'InitialReferralData', appealId: string, condition: string, medication: string, denialReason: string } };

export type GetAppealStatusQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealStatusQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, status: { __typename?: 'AppealStatus', referred?: boolean | null } } | null };

export type GetAppealStatusForDiagnosisQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealStatusForDiagnosisQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, status: { __typename?: 'AppealStatus', referred?: boolean | null } } | null };

export type GetAppealStatusForMedicationHistoryQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealStatusForMedicationHistoryQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, status: { __typename?: 'AppealStatus', referred?: boolean | null } } | null };

export type GetAppealStatusForPatientQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealStatusForPatientQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, status: { __typename?: 'AppealStatus', referred?: boolean | null } } | null };

export type GetSurveyDataForPatientSurveyPageQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetSurveyDataForPatientSurveyPageQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, surveyJsAnswers: string, status: { __typename?: 'AppealStatus', referred?: boolean | null }, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null, denialReason?: string | null } | null } | null };

export type UpdateSurveyAnswersMutationVariables = Exact<{
  appealId: Scalars['ID']['input'];
  surveyJsAnswers: Scalars['String']['input'];
  surveySchemaId: Scalars['ID']['input'];
}>;


export type UpdateSurveyAnswersMutation = { __typename?: 'Mutation', updateSurveyJsAnswers?: boolean | null };

export type GetAppealStatusForPrescriberInformationQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealStatusForPrescriberInformationQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, status: { __typename?: 'AppealStatus', referred?: boolean | null } } | null };

export type ProviderWithFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderWithFacilitiesQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, facilities: Array<{ __typename?: 'ProviderFacility', providerFacilityId: string, facilityName: string, facilityShortName: string }> } | null };

export type SaveReferralMutationVariables = Exact<{
  referral: ReferralInput;
}>;


export type SaveReferralMutation = { __typename?: 'Mutation', saveReferral: { __typename?: 'ReferralOutput', appealId: string, referralId: string, denialLetterLinks?: Array<{ __typename?: 'UploadLink', fileExtension: string, uploadUrl: string }> | null, medLetterLinks?: Array<{ __typename?: 'UploadLink', fileExtension: string, uploadUrl: string }> | null } };

export type GetAppealByIdForRedirectQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetAppealByIdForRedirectQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string } | null };

export type ProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, users: Array<{ __typename?: 'ProviderUser', providerUserId: string, providerId: string, email: string, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, role: ProviderUserRole, active: boolean, createdTimestamp: any }> } | null };

export type ProviderUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderUserQuery = { __typename?: 'Query', providerUser?: { __typename?: 'ProviderUser', providerUserId: string, role: ProviderUserRole } | null };

export type UpdateProviderUserActiveStatusMutationVariables = Exact<{
  providerUserId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type UpdateProviderUserActiveStatusMutation = { __typename?: 'Mutation', updateProviderUserActiveStatus: { __typename?: 'ProviderUser', providerUserId: string, active: boolean } };

export type AddNewUserToProviderMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AddNewUserToProviderMutation = { __typename?: 'Mutation', addNewUserToProvider?: { __typename?: 'ProviderUser', providerUserId: string } | null };

export type CreateAppealPackageCheckoutSessionMutationVariables = Exact<{
  appealPackage: AppealPackage;
}>;


export type CreateAppealPackageCheckoutSessionMutation = { __typename?: 'Mutation', createAppealPackageCheckoutSession: string };

export type ProviderInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderInfoQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', providerId: string, providerName: string, users: Array<{ __typename?: 'ProviderUser', email: string }>, sponsoredAppeals?: { __typename?: 'SponsoredAppeals', totalRemaining: number } | null, purchases?: Array<{ __typename?: 'Purchase', providerUserId: string, appealPackageName: string, appealQuantity: number, amountSubtotal: number, amountTax: number, amountTotal: number, paymentTimestamp?: any | null }> | null } | null };

export type ProviderCheckoutSessionStatusQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type ProviderCheckoutSessionStatusQuery = { __typename?: 'Query', providerCheckoutSessionStatus?: { __typename?: 'ProviderCheckoutSessionStatus', complete: boolean } | null };

export type GetPatientInfoForStrengthenQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetPatientInfoForStrengthenQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, referralPatientEmail?: string | null, sponsorshipExpiredTimestamp?: any | null, patient?: { __typename?: 'Patient', firstName: string, lastName: string, dateOfBirth: any } | null, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null } | null, status: { __typename?: 'AppealStatus', referred?: boolean | null, insuranceCardUpload?: boolean | null, insuranceCardUploadSkipped?: boolean | null, paymentSuccessful?: boolean | null, issueOutstanding?: boolean | null, denialUpheld?: boolean | null, denialOverturned?: boolean | null, appealSubmitted?: boolean | null } } | null };

export type GetSurveyDataForAppealQueryVariables = Exact<{
  appealId: Scalars['ID']['input'];
}>;


export type GetSurveyDataForAppealQuery = { __typename?: 'Query', getAppealById?: { __typename?: 'Appeal', appealId: string, surveyJsAnswers: string, denial?: { __typename?: 'Denial', condition?: string | null, medicationBrandName?: string | null, denialReason?: string | null } | null } | null };


export const ReportAppealStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportAppealStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportAppealStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportAppealOutcomeStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}]}}]} as unknown as DocumentNode<ReportAppealStatusMutation, ReportAppealStatusMutationVariables>;
export const GetAppealInsuranceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealInsurance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"planCategory"}},{"kind":"Field","name":{"kind":"Name","value":"employer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberNumber"}},{"kind":"Field","name":{"kind":"Name","value":"groupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rxGroupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rxBinNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pbmName"}},{"kind":"Field","name":{"kind":"Name","value":"isPatientEnrollee"}},{"kind":"Field","name":{"kind":"Name","value":"enrolleeFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"enrolleeLastName"}},{"kind":"Field","name":{"kind":"Name","value":"denyingParty"}},{"kind":"Field","name":{"kind":"Name","value":"otherDenyingPartyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denialReason"}},{"kind":"Field","name":{"kind":"Name","value":"subDenialReasons"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealInsuranceQuery, GetAppealInsuranceQueryVariables>;
export const SaveInsuranceInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveInsuranceInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insuranceInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveInsuranceInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveInsuranceInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"insuranceInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insuranceInfo"}}}]}]}}]} as unknown as DocumentNode<SaveInsuranceInfoMutation, SaveInsuranceInfoMutationVariables>;
export const GetProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"hasSignedBAA"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}}]}}]} as unknown as DocumentNode<GetProviderQuery, GetProviderQueryVariables>;
export const GetProviderForPatientFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProviderForPatientForm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"hasSignedBAA"}}]}}]}}]} as unknown as DocumentNode<GetProviderForPatientFormQuery, GetProviderForPatientFormQueryVariables>;
export const GetAppealByIdForPatientFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealByIdForPatientForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"referringProviderName"}},{"kind":"Field","name":{"kind":"Name","value":"referralPatientEmail"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caregiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referral"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerMessage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPatientConsent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportingDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeAll"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealByIdForPatientFormQuery, GetAppealByIdForPatientFormQueryVariables>;
export const SavePatientAndCaregiverInfoOnReferralFromFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SavePatientAndCaregiverInfoOnReferralFromForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SavePatientAndCaregiverInfoOnReferralInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savePatientAndCaregiverInfoOnReferral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SavePatientAndCaregiverInfoOnReferralFromFormMutation, SavePatientAndCaregiverInfoOnReferralFromFormMutationVariables>;
export const UpsertConsentDocumentFromFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertConsentDocumentFromForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertAppealSupportingDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAppealSupportingDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUrls"}}]}}]}}]} as unknown as DocumentNode<UpsertConsentDocumentFromFormMutation, UpsertConsentDocumentFromFormMutationVariables>;
export const ProviderAndUserForDefaultMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderAndUserForDefaultMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultReferralMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<ProviderAndUserForDefaultMessageQuery, ProviderAndUserForDefaultMessageQueryVariables>;
export const SaveProviderDefaultReferralMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveProviderDefaultReferralMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveProviderDefaultReferralMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultReferralMessage"}}]}}]}}]} as unknown as DocumentNode<SaveProviderDefaultReferralMessageMutation, SaveProviderDefaultReferralMessageMutationVariables>;
export const GetAppealForProgressTrackerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealForProgressTracker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealForProgressTrackerQuery, GetAppealForProgressTrackerQueryVariables>;
export const SendReferralToPatientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendReferralToPatient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendReferralToPatient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<SendReferralToPatientMutation, SendReferralToPatientMutationVariables>;
export const DownloadAppealLetterLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DownloadAppealLetterLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadAppealLetterLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}]}]}}]} as unknown as DocumentNode<DownloadAppealLetterLinkMutation, DownloadAppealLetterLinkMutationVariables>;
export const GetSupportingDocumentsForAppealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportingDocumentsForAppeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportingDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"otherDocumentTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referralPatientEmail"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}}]}}]}}]}}]} as unknown as DocumentNode<GetSupportingDocumentsForAppealQuery, GetSupportingDocumentsForAppealQueryVariables>;
export const UpsertAppealSupportingDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAppealSupportingDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertAppealSupportingDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAppealSupportingDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"}},{"kind":"Field","name":{"kind":"Name","value":"otherDocumentTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrls"}}]}}]}}]} as unknown as DocumentNode<UpsertAppealSupportingDocumentMutation, UpsertAppealSupportingDocumentMutationVariables>;
export const DeleteAppealSupportingDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAppealSupportingDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAppealSupportingDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}}]}]}}]} as unknown as DocumentNode<DeleteAppealSupportingDocumentMutation, DeleteAppealSupportingDocumentMutationVariables>;
export const CreateProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProviderViaSelfSignUpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProviderViaSelfSignUp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"hasSignedBAA"}}]}}]}}]} as unknown as DocumentNode<CreateProviderMutation, CreateProviderMutationVariables>;
export const UpdateProviderUserInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProviderUserInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProviderUserInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProviderUserInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUserId"}}]}}]}}]} as unknown as DocumentNode<UpdateProviderUserInfoMutation, UpdateProviderUserInfoMutationVariables>;
export const SignBaaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignBAA"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signProviderBusinessAssociateAgreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"hasSignedBAA"}}]}}]}}]} as unknown as DocumentNode<SignBaaMutation, SignBaaMutationVariables>;
export const ProviderQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"hasSignedBAA"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ProviderQueryQuery, ProviderQueryQueryVariables>;
export const ProviderUserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderUserQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<ProviderUserQueryQuery, ProviderUserQueryQueryVariables>;
export const DownloadBaaFormLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DownloadBAAFormLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadBAAFormLink"}}]}}]} as unknown as DocumentNode<DownloadBaaFormLinkMutation, DownloadBaaFormLinkMutationVariables>;
export const ProviderPurchaseInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderPurchaseInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialEndTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"createdTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sponsoredAppeals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRemaining"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealQuantity"}}]}}]}}]}}]} as unknown as DocumentNode<ProviderPurchaseInfoQuery, ProviderPurchaseInfoQueryVariables>;
export const ProviderReferralsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderReferrals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralsFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referrals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referrals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralId"}},{"kind":"Field","name":{"kind":"Name","value":"patientEmail"}},{"kind":"Field","name":{"kind":"Name","value":"referringUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appeal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"referringProviderName"}},{"kind":"Field","name":{"kind":"Name","value":"createdTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"updatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"sponsoringParty"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorshipExpiredTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCardUpload"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCardUploadSkipped"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"issueOutstanding"}},{"kind":"Field","name":{"kind":"Name","value":"denialUpheld"}},{"kind":"Field","name":{"kind":"Name","value":"denialOverturned"}},{"kind":"Field","name":{"kind":"Name","value":"appealSubmitted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referringFacilityName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerFacilityId"}}]}}]}}]}}]} as unknown as DocumentNode<ProviderReferralsQuery, ProviderReferralsQueryVariables>;
export const GetProviderForSucraidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProviderForSucraid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}}]}}]} as unknown as DocumentNode<GetProviderForSucraidQuery, GetProviderForSucraidQueryVariables>;
export const ProviderTypeHookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderTypeHook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ProviderTypeHookQuery, ProviderTypeHookQueryVariables>;
export const ProviderWithFacilitiesHookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderWithFacilitiesHook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerFacilityId"}}]}}]}}]}}]} as unknown as DocumentNode<ProviderWithFacilitiesHookQuery, ProviderWithFacilitiesHookQueryVariables>;
export const GetPublishedSurveySchemaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublishedSurveySchema"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedSurveySchema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schemaData"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}}]}}]}}]} as unknown as DocumentNode<GetPublishedSurveySchemaQuery, GetPublishedSurveySchemaQueryVariables>;
export const GetAppealStatusForDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealStatusForDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealStatusForDocumentsQuery, GetAppealStatusForDocumentsQueryVariables>;
export const InitializeReferralDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitializeReferral"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitializeReferralInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initializeReferral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medication"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}}]}}]}}]} as unknown as DocumentNode<InitializeReferralMutation, InitializeReferralMutationVariables>;
export const GetAppealStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealStatusQuery, GetAppealStatusQueryVariables>;
export const GetAppealStatusForDiagnosisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealStatusForDiagnosis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealStatusForDiagnosisQuery, GetAppealStatusForDiagnosisQueryVariables>;
export const GetAppealStatusForMedicationHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealStatusForMedicationHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealStatusForMedicationHistoryQuery, GetAppealStatusForMedicationHistoryQueryVariables>;
export const GetAppealStatusForPatientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealStatusForPatient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealStatusForPatientQuery, GetAppealStatusForPatientQueryVariables>;
export const GetSurveyDataForPatientSurveyPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSurveyDataForPatientSurveyPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"surveyJsAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}}]}}]}}]}}]} as unknown as DocumentNode<GetSurveyDataForPatientSurveyPageQuery, GetSurveyDataForPatientSurveyPageQueryVariables>;
export const UpdateSurveyAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSurveyAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyJsAnswers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveySchemaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSurveyJsAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"surveyJsAnswers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyJsAnswers"}}},{"kind":"Argument","name":{"kind":"Name","value":"surveySchemaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveySchemaId"}}}]}]}}]} as unknown as DocumentNode<UpdateSurveyAnswersMutation, UpdateSurveyAnswersMutationVariables>;
export const GetAppealStatusForPrescriberInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealStatusForPrescriberInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppealStatusForPrescriberInformationQuery, GetAppealStatusForPrescriberInformationQueryVariables>;
export const ProviderWithFacilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderWithFacilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerFacilityId"}},{"kind":"Field","name":{"kind":"Name","value":"facilityName"}},{"kind":"Field","name":{"kind":"Name","value":"facilityShortName"}}]}}]}}]}}]} as unknown as DocumentNode<ProviderWithFacilitiesQuery, ProviderWithFacilitiesQueryVariables>;
export const SaveReferralDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveReferral"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referral"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveReferral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referral"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referral"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"referralId"}},{"kind":"Field","name":{"kind":"Name","value":"denialLetterLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medLetterLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}}]}}]} as unknown as DocumentNode<SaveReferralMutation, SaveReferralMutationVariables>;
export const GetAppealByIdForRedirectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppealByIdForRedirect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}}]}}]}}]} as unknown as DocumentNode<GetAppealByIdForRedirectQuery, GetAppealByIdForRedirectQueryVariables>;
export const ProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdTimestamp"}}]}}]}}]}}]} as unknown as DocumentNode<ProviderQuery, ProviderQueryVariables>;
export const ProviderUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<ProviderUserQuery, ProviderUserQueryVariables>;
export const UpdateProviderUserActiveStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProviderUserActiveStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProviderUserActiveStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<UpdateProviderUserActiveStatusMutation, UpdateProviderUserActiveStatusMutationVariables>;
export const AddNewUserToProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNewUserToProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNewUserToProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUserId"}}]}}]}}]} as unknown as DocumentNode<AddNewUserToProviderMutation, AddNewUserToProviderMutationVariables>;
export const CreateAppealPackageCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppealPackageCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealPackage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppealPackage"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAppealPackageCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealPackage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealPackage"}}}]}]}}]} as unknown as DocumentNode<CreateAppealPackageCheckoutSessionMutation, CreateAppealPackageCheckoutSessionMutationVariables>;
export const ProviderInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sponsoredAppeals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRemaining"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"appealPackageName"}},{"kind":"Field","name":{"kind":"Name","value":"appealQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"amountSubtotal"}},{"kind":"Field","name":{"kind":"Name","value":"amountTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountTotal"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTimestamp"}}]}}]}}]}}]} as unknown as DocumentNode<ProviderInfoQuery, ProviderInfoQueryVariables>;
export const ProviderCheckoutSessionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderCheckoutSessionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerCheckoutSessionStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}}]}}]} as unknown as DocumentNode<ProviderCheckoutSessionStatusQuery, ProviderCheckoutSessionStatusQueryVariables>;
export const GetPatientInfoForStrengthenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPatientInfoForStrengthen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"referralPatientEmail"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorshipExpiredTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referred"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCardUpload"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCardUploadSkipped"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"issueOutstanding"}},{"kind":"Field","name":{"kind":"Name","value":"denialUpheld"}},{"kind":"Field","name":{"kind":"Name","value":"denialOverturned"}},{"kind":"Field","name":{"kind":"Name","value":"appealSubmitted"}}]}}]}}]}}]} as unknown as DocumentNode<GetPatientInfoForStrengthenQuery, GetPatientInfoForStrengthenQueryVariables>;
export const GetSurveyDataForAppealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSurveyDataForAppeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppealById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appealId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appealId"}},{"kind":"Field","name":{"kind":"Name","value":"surveyJsAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"denial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"medicationBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"denialReason"}}]}}]}}]}}]} as unknown as DocumentNode<GetSurveyDataForAppealQuery, GetSurveyDataForAppealQueryVariables>;
export type AddressKeySpecifier = ('addressLine1' | 'addressLine2' | 'city' | 'state' | 'zip' | AddressKeySpecifier)[];
export type AddressFieldPolicy = {
	addressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	zip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealKeySpecifier = ('appealId' | 'appealLetter' | 'appealType' | 'caregiver' | 'ccDestinations' | 'couponId' | 'createdTimestamp' | 'denial' | 'destination' | 'formattedSurveyAnswers' | 'isCoverageFund' | 'isExpeditedReview' | 'originalAppealId' | 'partnerId' | 'partnerName' | 'partnerPatientEmail' | 'patient' | 'patientInsurance' | 'referral' | 'referralId' | 'referralPatientEmail' | 'referringFacilityId' | 'referringFacilityName' | 'referringFacilityShortName' | 'referringProviderId' | 'referringProviderName' | 'referringProviderType' | 'sentFaxes' | 'sentLetters' | 'sponsoringParty' | 'sponsorshipExpiredTimestamp' | 'status' | 'supportingDocuments' | 'surveyAnswers' | 'surveyId' | 'surveyJsAnswers' | 'updatedTimestamp' | 'userEmail' | 'userId' | AppealKeySpecifier)[];
export type AppealFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	appealLetter?: FieldPolicy<any> | FieldReadFunction<any>,
	appealType?: FieldPolicy<any> | FieldReadFunction<any>,
	caregiver?: FieldPolicy<any> | FieldReadFunction<any>,
	ccDestinations?: FieldPolicy<any> | FieldReadFunction<any>,
	couponId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	denial?: FieldPolicy<any> | FieldReadFunction<any>,
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedSurveyAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	isCoverageFund?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpeditedReview?: FieldPolicy<any> | FieldReadFunction<any>,
	originalAppealId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerName?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerPatientEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	patientInsurance?: FieldPolicy<any> | FieldReadFunction<any>,
	referral?: FieldPolicy<any> | FieldReadFunction<any>,
	referralId?: FieldPolicy<any> | FieldReadFunction<any>,
	referralPatientEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	referringFacilityId?: FieldPolicy<any> | FieldReadFunction<any>,
	referringFacilityName?: FieldPolicy<any> | FieldReadFunction<any>,
	referringFacilityShortName?: FieldPolicy<any> | FieldReadFunction<any>,
	referringProviderId?: FieldPolicy<any> | FieldReadFunction<any>,
	referringProviderName?: FieldPolicy<any> | FieldReadFunction<any>,
	referringProviderType?: FieldPolicy<any> | FieldReadFunction<any>,
	sentFaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	sentLetters?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsoringParty?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorshipExpiredTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	supportingDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyId?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyJsAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealDestinationKeySpecifier = ('address' | 'company' | 'email' | 'fax' | 'name' | 'phone' | 'recipientType' | AppealDestinationKeySpecifier)[];
export type AppealDestinationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	fax?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealLetterKeySpecifier = ('body' | 'references' | AppealLetterKeySpecifier)[];
export type AppealLetterFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	references?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealStatusKeySpecifier = ('appealLetterGenerated' | 'appealSubmitted' | 'appealSubmittedTimestamp' | 'closed' | 'denialLetterExtracted' | 'denialLetterExtractionFailed' | 'denialLetterUpload' | 'denialLetterUploadSkipped' | 'denialOverturned' | 'denialOverturnedTimestamp' | 'denialUpheld' | 'denialUpheldTimestamp' | 'enterpriseSubmissionInitiated' | 'failedSendingAllAppeals' | 'informationConfirmed' | 'initiated' | 'insuranceCardExtracted' | 'insuranceCardExtractionFailed' | 'insuranceCardUpload' | 'insuranceCardUploadSkipped' | 'issueOutstanding' | 'letterGenerationFailed' | 'letterOfMedicalNecessityUploaded' | 'patientSavedExperience' | 'paymentFailed' | 'paymentSuccessful' | 'pdfGenerated' | 'pdfGenerationFailed' | 'referred' | 'secondAppealRequested' | 'secondAppealRequestedTimestamp' | AppealStatusKeySpecifier)[];
export type AppealStatusFieldPolicy = {
	appealLetterGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	appealSubmitted?: FieldPolicy<any> | FieldReadFunction<any>,
	appealSubmittedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterExtracted?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterExtractionFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterUploadSkipped?: FieldPolicy<any> | FieldReadFunction<any>,
	denialOverturned?: FieldPolicy<any> | FieldReadFunction<any>,
	denialOverturnedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	denialUpheld?: FieldPolicy<any> | FieldReadFunction<any>,
	denialUpheldTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseSubmissionInitiated?: FieldPolicy<any> | FieldReadFunction<any>,
	failedSendingAllAppeals?: FieldPolicy<any> | FieldReadFunction<any>,
	informationConfirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	initiated?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCardExtracted?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCardExtractionFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCardUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCardUploadSkipped?: FieldPolicy<any> | FieldReadFunction<any>,
	issueOutstanding?: FieldPolicy<any> | FieldReadFunction<any>,
	letterGenerationFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	letterOfMedicalNecessityUploaded?: FieldPolicy<any> | FieldReadFunction<any>,
	patientSavedExperience?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentSuccessful?: FieldPolicy<any> | FieldReadFunction<any>,
	pdfGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	pdfGenerationFailed?: FieldPolicy<any> | FieldReadFunction<any>,
	referred?: FieldPolicy<any> | FieldReadFunction<any>,
	secondAppealRequested?: FieldPolicy<any> | FieldReadFunction<any>,
	secondAppealRequestedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealSupportingDocumentKeySpecifier = ('documentId' | 'documentType' | 'files' | 'isIncludedInAppeal' | 'otherDocumentTypeName' | 'uploadedBy' | AppealSupportingDocumentKeySpecifier)[];
export type AppealSupportingDocumentFieldPolicy = {
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	isIncludedInAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	otherDocumentTypeName?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppealSupportingDocumentFileKeySpecifier = ('fileId' | 'fileName' | 'fileType' | 'url' | AppealSupportingDocumentFileKeySpecifier)[];
export type AppealSupportingDocumentFileFieldPolicy = {
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	fileType?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaregiverKeySpecifier = ('dateOfBirth' | 'firstName' | 'lastName' | 'relationship' | CaregiverKeySpecifier)[];
export type CaregiverFieldPolicy = {
	dateOfBirth?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CcDestinationKeySpecifier = ('destination' | 'sendMethod' | CcDestinationKeySpecifier)[];
export type CcDestinationFieldPolicy = {
	destination?: FieldPolicy<any> | FieldReadFunction<any>,
	sendMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClinicalEvidenceKeySpecifier = ('abstract' | 'citation' | 'condition' | 'id' | 'medication' | 'tags' | ClinicalEvidenceKeySpecifier)[];
export type ClinicalEvidenceFieldPolicy = {
	abstract?: FieldPolicy<any> | FieldReadFunction<any>,
	citation?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenialKeySpecifier = ('bmiComorbidCriteria' | 'bmiObesityCriteria' | 'claimId' | 'condition' | 'daysToAppeal' | 'denialDate' | 'denialReason' | 'medicationBrandName' | 'medicationGenericName' | 'subDenialReasons' | DenialKeySpecifier)[];
export type DenialFieldPolicy = {
	bmiComorbidCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	bmiObesityCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	claimId?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	daysToAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	denialDate?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationBrandName?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationGenericName?: FieldPolicy<any> | FieldReadFunction<any>,
	subDenialReasons?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenialLetterKeySpecifier = ('confirmed' | 'extracted' | 's3Urls' | DenialLetterKeySpecifier)[];
export type DenialLetterFieldPolicy = {
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	extracted?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Urls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenialLetterFileKeySpecifier = ('url' | DenialLetterFileKeySpecifier)[];
export type DenialLetterFileFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenialLetterInfoKeySpecifier = ('daysToAppeal' | 'denialDate' | 'denialReason' | 'disease' | 'medicationBrandName' | 'medicationGenericName' | DenialLetterInfoKeySpecifier)[];
export type DenialLetterInfoFieldPolicy = {
	daysToAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	denialDate?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	disease?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationBrandName?: FieldPolicy<any> | FieldReadFunction<any>,
	medicationGenericName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DenyingPartyAppealDepartmentKeySpecifier = ('address' | 'company' | 'fax' | 'name' | DenyingPartyAppealDepartmentKeySpecifier)[];
export type DenyingPartyAppealDepartmentFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	fax?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmployerKeySpecifier = ('address' | 'employerName' | 'fax' | 'recipientName' | EmployerKeySpecifier)[];
export type EmployerFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	employerName?: FieldPolicy<any> | FieldReadFunction<any>,
	fax?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GatherClinicalEvidenceResultKeySpecifier = ('papersInserted' | GatherClinicalEvidenceResultKeySpecifier)[];
export type GatherClinicalEvidenceResultFieldPolicy = {
	papersInserted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HistoryQuestionKeySpecifier = ('answer' | 'question' | HistoryQuestionKeySpecifier)[];
export type HistoryQuestionFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InReviewClinicalEvidenceKeySpecifier = ('abstract' | 'citation' | 'condition' | 'id' | 'medication' | 'numberOfCitations' | InReviewClinicalEvidenceKeySpecifier)[];
export type InReviewClinicalEvidenceFieldPolicy = {
	abstract?: FieldPolicy<any> | FieldReadFunction<any>,
	citation?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfCitations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InitialReferralDataKeySpecifier = ('appealId' | 'condition' | 'denialReason' | 'medication' | InitialReferralDataKeySpecifier)[];
export type InitialReferralDataFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	denialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsuranceInfoKeySpecifier = ('confirmed' | 'extracted' | 's3Url' | InsuranceInfoKeySpecifier)[];
export type InsuranceInfoFieldPolicy = {
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	extracted?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsuranceInfoDetailsKeySpecifier = ('birthDate' | 'claimId' | 'denyingParty' | 'employer' | 'enrolleeFirstName' | 'enrolleeLastName' | 'groupNumber' | 'insuranceProvider' | 'insuranceType' | 'isPatientEnrollee' | 'memberNumber' | 'otherAppealSituations' | 'otherDenyingPartyName' | 'pbmName' | 'planCategory' | 'rxBinNumber' | 'rxGroupNumber' | 'state' | InsuranceInfoDetailsKeySpecifier)[];
export type InsuranceInfoDetailsFieldPolicy = {
	birthDate?: FieldPolicy<any> | FieldReadFunction<any>,
	claimId?: FieldPolicy<any> | FieldReadFunction<any>,
	denyingParty?: FieldPolicy<any> | FieldReadFunction<any>,
	employer?: FieldPolicy<any> | FieldReadFunction<any>,
	enrolleeFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	enrolleeLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	groupNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceType?: FieldPolicy<any> | FieldReadFunction<any>,
	isPatientEnrollee?: FieldPolicy<any> | FieldReadFunction<any>,
	memberNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	otherAppealSituations?: FieldPolicy<any> | FieldReadFunction<any>,
	otherDenyingPartyName?: FieldPolicy<any> | FieldReadFunction<any>,
	pbmName?: FieldPolicy<any> | FieldReadFunction<any>,
	planCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	rxBinNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rxGroupNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterGenerationKeySpecifier = ('appealLetterGenerationId' | 'createdTimestamp' | 'generationOutput' | 'letterBody' | 'letterReferences' | 'prompt' | 'updatedTimestamp' | LetterGenerationKeySpecifier)[];
export type LetterGenerationFieldPolicy = {
	appealLetterGenerationId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	generationOutput?: FieldPolicy<any> | FieldReadFunction<any>,
	letterBody?: FieldPolicy<any> | FieldReadFunction<any>,
	letterReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterOfNecessityInfoKeySpecifier = ('s3Urls' | LetterOfNecessityInfoKeySpecifier)[];
export type LetterOfNecessityInfoFieldPolicy = {
	s3Urls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LetterRevisionHistoryKeySpecifier = ('comment' | 'createdTimestamp' | 'reason' | 'supportUserEmail' | 'supportUserId' | LetterRevisionHistoryKeySpecifier)[];
export type LetterRevisionHistoryFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	supportUserEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	supportUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualAppealSendResponseKeySpecifier = ('error' | 'letterSent' | 'letterTrackingId' | 'sentFax' | 'success' | ManualAppealSendResponseKeySpecifier)[];
export type ManualAppealSendResponseFieldPolicy = {
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	letterSent?: FieldPolicy<any> | FieldReadFunction<any>,
	letterTrackingId?: FieldPolicy<any> | FieldReadFunction<any>,
	sentFax?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MedicalHistoryKeySpecifier = ('questions' | MedicalHistoryKeySpecifier)[];
export type MedicalHistoryFieldPolicy = {
	questions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('UpdateProviderUserRole' | 'addClinicalEvidenceEntry' | 'addNewUserToProvider' | 'addNewUserToProviderByProviderId' | 'approvePayerPolicyExtraction' | 'archiveInReviewEvidence' | 'cloneAppeal' | 'closeAppeal' | 'confirmDetails' | 'createAppealLetterIssue' | 'createAppealPackageCheckoutSession' | 'createCheckoutSession' | 'createLetterRevision' | 'createProvider' | 'createProviderViaSelfSignUp' | 'createSurveySchema' | 'createSurveySchemaVersion' | 'deleteAppealSupportingDocument' | 'denialLetterUploadLinks' | 'denialUpheldLetterLinks' | 'downloadAppealLetterLink' | 'downloadBAAFormLink' | 'editSurveySchema' | 'gatherClinicalEvidence' | 'generateFinalPDF' | 'initializeReferral' | 'initiateAppeal' | 'insertUserEvent' | 'insuranceCardUploadLinks' | 'markAppealReadyForReview' | 'medicalLetterOfNecessityLinks' | 'previewAppealPdf' | 'publishSurveySchema' | 'removeAppealOutcomeStatus' | 'reportAppealOutcomeStatus' | 'requestSecondAppeal' | 'resolveIssue' | 'saveAppealDeptData' | 'saveCCDestinations' | 'saveCaregiverData' | 'saveDenialUpheldDenialReason' | 'saveDenialUpheldReceivedClaimsFile' | 'saveDenyingParty' | 'saveInsuranceEmployer' | 'saveInsuranceInfo' | 'saveIsExpeditedReview' | 'saveOtherAppealSituations' | 'savePatientAndCaregiverInfoOnReferral' | 'savePatientData' | 'savePrimaryEnrollee' | 'saveProviderDefaultReferralMessage' | 'saveReferral' | 'sendAppealManually' | 'sendReferralToPatient' | 'setupNewUserWithExistingReferrals' | 'signProviderBusinessAssociateAgreement' | 'skipUpload' | 'startGenerateAppeal' | 'startNextAppeal' | 'submitEnterpriseAppeal' | 'toggleAppealSupportingDocumentInclusion' | 'toggleClaimableAppealSponsorship' | 'updateAppealDenialReasons' | 'updateAppealPlanCategory' | 'updateAppealType' | 'updatePayerPolicyExtraction' | 'updateProviderFreeTrialEndDate' | 'updateProviderUserActiveStatus' | 'updateProviderUserInfo' | 'updateSurveyAnswers' | 'updateSurveyJsAnswers' | 'upsertAppealSupportingDocument' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	UpdateProviderUserRole?: FieldPolicy<any> | FieldReadFunction<any>,
	addClinicalEvidenceEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	addNewUserToProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	addNewUserToProviderByProviderId?: FieldPolicy<any> | FieldReadFunction<any>,
	approvePayerPolicyExtraction?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveInReviewEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	cloneAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	closeAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppealLetterIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppealPackageCheckoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createCheckoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createLetterRevision?: FieldPolicy<any> | FieldReadFunction<any>,
	createProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	createProviderViaSelfSignUp?: FieldPolicy<any> | FieldReadFunction<any>,
	createSurveySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	createSurveySchemaVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAppealSupportingDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterUploadLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	denialUpheldLetterLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadAppealLetterLink?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadBAAFormLink?: FieldPolicy<any> | FieldReadFunction<any>,
	editSurveySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	gatherClinicalEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	generateFinalPDF?: FieldPolicy<any> | FieldReadFunction<any>,
	initializeReferral?: FieldPolicy<any> | FieldReadFunction<any>,
	initiateAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	insertUserEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCardUploadLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	markAppealReadyForReview?: FieldPolicy<any> | FieldReadFunction<any>,
	medicalLetterOfNecessityLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	previewAppealPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	publishSurveySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	removeAppealOutcomeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	reportAppealOutcomeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	requestSecondAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	resolveIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	saveAppealDeptData?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCCDestinations?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCaregiverData?: FieldPolicy<any> | FieldReadFunction<any>,
	saveDenialUpheldDenialReason?: FieldPolicy<any> | FieldReadFunction<any>,
	saveDenialUpheldReceivedClaimsFile?: FieldPolicy<any> | FieldReadFunction<any>,
	saveDenyingParty?: FieldPolicy<any> | FieldReadFunction<any>,
	saveInsuranceEmployer?: FieldPolicy<any> | FieldReadFunction<any>,
	saveInsuranceInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	saveIsExpeditedReview?: FieldPolicy<any> | FieldReadFunction<any>,
	saveOtherAppealSituations?: FieldPolicy<any> | FieldReadFunction<any>,
	savePatientAndCaregiverInfoOnReferral?: FieldPolicy<any> | FieldReadFunction<any>,
	savePatientData?: FieldPolicy<any> | FieldReadFunction<any>,
	savePrimaryEnrollee?: FieldPolicy<any> | FieldReadFunction<any>,
	saveProviderDefaultReferralMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	saveReferral?: FieldPolicy<any> | FieldReadFunction<any>,
	sendAppealManually?: FieldPolicy<any> | FieldReadFunction<any>,
	sendReferralToPatient?: FieldPolicy<any> | FieldReadFunction<any>,
	setupNewUserWithExistingReferrals?: FieldPolicy<any> | FieldReadFunction<any>,
	signProviderBusinessAssociateAgreement?: FieldPolicy<any> | FieldReadFunction<any>,
	skipUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	startGenerateAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	startNextAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	submitEnterpriseAppeal?: FieldPolicy<any> | FieldReadFunction<any>,
	toggleAppealSupportingDocumentInclusion?: FieldPolicy<any> | FieldReadFunction<any>,
	toggleClaimableAppealSponsorship?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealDenialReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealPlanCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAppealType?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePayerPolicyExtraction?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProviderFreeTrialEndDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProviderUserActiveStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProviderUserInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSurveyAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSurveyJsAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertAppealSupportingDocument?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedAppealsKeySpecifier = ('data' | 'totalCount' | PaginatedAppealsKeySpecifier)[];
export type PaginatedAppealsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedClinicalEvidenceKeySpecifier = ('data' | 'totalCount' | PaginatedClinicalEvidenceKeySpecifier)[];
export type PaginatedClinicalEvidenceFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedInReviewClinicalEvidenceKeySpecifier = ('data' | 'totalCount' | PaginatedInReviewClinicalEvidenceKeySpecifier)[];
export type PaginatedInReviewClinicalEvidenceFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedPayerPolicyClinicalCriteriaKeySpecifier = ('data' | 'totalCount' | PaginatedPayerPolicyClinicalCriteriaKeySpecifier)[];
export type PaginatedPayerPolicyClinicalCriteriaFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedPayerPolicyExtractionKeySpecifier = ('data' | 'totalCount' | PaginatedPayerPolicyExtractionKeySpecifier)[];
export type PaginatedPayerPolicyExtractionFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedProvidersKeySpecifier = ('data' | 'totalCount' | PaginatedProvidersKeySpecifier)[];
export type PaginatedProvidersFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedReferralsKeySpecifier = ('referrals' | 'totalCount' | PaginatedReferralsKeySpecifier)[];
export type PaginatedReferralsFieldPolicy = {
	referrals?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientKeySpecifier = ('address' | 'dateOfBirth' | 'firstName' | 'lastName' | 'phone' | 'pronouns' | 'sex' | PatientKeySpecifier)[];
export type PatientFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	dateOfBirth?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	pronouns?: FieldPolicy<any> | FieldReadFunction<any>,
	sex?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientInsuranceKeySpecifier = ('denyingParty' | 'employer' | 'enrolleeFirstName' | 'enrolleeLastName' | 'groupNumber' | 'insuranceType' | 'isPatientEnrollee' | 'memberNumber' | 'otherAppealSituations' | 'otherDenyingPartyName' | 'pbmName' | 'planCategory' | 'providerName' | 'rxBinNumber' | 'rxGroupNumber' | 'state' | PatientInsuranceKeySpecifier)[];
export type PatientInsuranceFieldPolicy = {
	denyingParty?: FieldPolicy<any> | FieldReadFunction<any>,
	employer?: FieldPolicy<any> | FieldReadFunction<any>,
	enrolleeFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	enrolleeLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	groupNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceType?: FieldPolicy<any> | FieldReadFunction<any>,
	isPatientEnrollee?: FieldPolicy<any> | FieldReadFunction<any>,
	memberNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	otherAppealSituations?: FieldPolicy<any> | FieldReadFunction<any>,
	otherDenyingPartyName?: FieldPolicy<any> | FieldReadFunction<any>,
	pbmName?: FieldPolicy<any> | FieldReadFunction<any>,
	planCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	providerName?: FieldPolicy<any> | FieldReadFunction<any>,
	rxBinNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rxGroupNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayerPolicyClinicalCriteriaKeySpecifier = ('condition' | 'continuationClinicalCriteria' | 'id' | 'initialClinicalCriteria' | 'medication' | 'payer' | PayerPolicyClinicalCriteriaKeySpecifier)[];
export type PayerPolicyClinicalCriteriaFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	continuationClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	initialClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	payer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayerPolicyExtractionKeySpecifier = ('approvingUserId' | 'condition' | 'continuationClinicalCriteria' | 'createdAt' | 'id' | 'initialClinicalCriteria' | 'medication' | 'payer' | 'payerPolicyClinicalCriteriaId' | 'policyBotId' | 'updatedAt' | PayerPolicyExtractionKeySpecifier)[];
export type PayerPolicyExtractionFieldPolicy = {
	approvingUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	continuationClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	initialClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	medication?: FieldPolicy<any> | FieldReadFunction<any>,
	payer?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyClinicalCriteriaId?: FieldPolicy<any> | FieldReadFunction<any>,
	policyBotId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentKeySpecifier = ('amountDiscount' | 'amountSubtotal' | 'amountTax' | 'amountTotal' | 'appealPrice' | 'checkoutSessionId' | 'destinationPrice' | 'destinationQuantity' | 'paymentIntentId' | 'paymentMethodType' | 'paymentStatus' | 'paymentTimestamp' | 'shippingAmount' | PaymentKeySpecifier)[];
export type PaymentFieldPolicy = {
	amountDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	amountSubtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	amountTax?: FieldPolicy<any> | FieldReadFunction<any>,
	amountTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	appealPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	destinationPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	destinationQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentIntentId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodType?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductPricesKeySpecifier = ('appealPrice' | 'ccDestinationPrice' | 'shippingRate' | ProductPricesKeySpecifier)[];
export type ProductPricesFieldPolicy = {
	appealPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	ccDestinationPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderKeySpecifier = ('createdTimestamp' | 'defaultReferralMessage' | 'facilities' | 'freeTrialEndTimestamp' | 'hasSignedBAA' | 'identificationNumber' | 'organizationType' | 'providerId' | 'providerName' | 'purchases' | 'specialty' | 'sponsoredAppeals' | 'type' | 'users' | ProviderKeySpecifier)[];
export type ProviderFieldPolicy = {
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultReferralMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	facilities?: FieldPolicy<any> | FieldReadFunction<any>,
	freeTrialEndTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSignedBAA?: FieldPolicy<any> | FieldReadFunction<any>,
	identificationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationType?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerName?: FieldPolicy<any> | FieldReadFunction<any>,
	purchases?: FieldPolicy<any> | FieldReadFunction<any>,
	specialty?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsoredAppeals?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderCheckoutSessionStatusKeySpecifier = ('complete' | ProviderCheckoutSessionStatusKeySpecifier)[];
export type ProviderCheckoutSessionStatusFieldPolicy = {
	complete?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderFacilityKeySpecifier = ('facilityName' | 'facilityShortName' | 'providerFacilityId' | ProviderFacilityKeySpecifier)[];
export type ProviderFacilityFieldPolicy = {
	facilityName?: FieldPolicy<any> | FieldReadFunction<any>,
	facilityShortName?: FieldPolicy<any> | FieldReadFunction<any>,
	providerFacilityId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderReferralKeySpecifier = ('appealId' | 'createdTimestamp' | 'hasPatientConsent' | 'providerMessage' | 'providerUserId' | 'referralId' | ProviderReferralKeySpecifier)[];
export type ProviderReferralFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPatientConsent?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	referralId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderUserKeySpecifier = ('active' | 'createdTimestamp' | 'email' | 'firstName' | 'jobTitle' | 'lastName' | 'providerId' | 'providerUserId' | 'role' | ProviderUserKeySpecifier)[];
export type ProviderUserFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	createdTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	jobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PurchaseKeySpecifier = ('amountSubtotal' | 'amountTax' | 'amountTotal' | 'appealPackageName' | 'appealQuantity' | 'cardNumber' | 'paymentTimestamp' | 'providerUserId' | PurchaseKeySpecifier)[];
export type PurchaseFieldPolicy = {
	amountSubtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	amountTax?: FieldPolicy<any> | FieldReadFunction<any>,
	amountTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	appealPackageName?: FieldPolicy<any> | FieldReadFunction<any>,
	appealQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	cardNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('appealDestinations' | 'appeals' | 'clinicalEvidence' | 'clinicalEvidenceTags' | 'denyingPartyAppealDepartment' | 'existingDenialLetterFiles' | 'getAllSurveySchemas' | 'getAppealById' | 'getAppealPayment' | 'getAppeals' | 'getLetterGenerations' | 'getLetterRevisions' | 'getPayerPolicyPresignedUrl' | 'getProviderById' | 'getReferringProviderUser' | 'getSurveySchemaById' | 'healthCheck' | 'inReviewClinicalEvidence' | 'payerPolicyClinicalCriteria' | 'payerPolicyExtraction' | 'payerPolicyExtractionPayerNames' | 'payerPolicyExtractions' | 'payerPolicyPayerNames' | 'productPrices' | 'provider' | 'providerCheckoutSessionStatus' | 'providerUser' | 'providers' | 'publishedSurveySchema' | 'referrals' | 'uploadInfo' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	appealDestinations?: FieldPolicy<any> | FieldReadFunction<any>,
	appeals?: FieldPolicy<any> | FieldReadFunction<any>,
	clinicalEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	clinicalEvidenceTags?: FieldPolicy<any> | FieldReadFunction<any>,
	denyingPartyAppealDepartment?: FieldPolicy<any> | FieldReadFunction<any>,
	existingDenialLetterFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllSurveySchemas?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppealById?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppealPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppeals?: FieldPolicy<any> | FieldReadFunction<any>,
	getLetterGenerations?: FieldPolicy<any> | FieldReadFunction<any>,
	getLetterRevisions?: FieldPolicy<any> | FieldReadFunction<any>,
	getPayerPolicyPresignedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	getProviderById?: FieldPolicy<any> | FieldReadFunction<any>,
	getReferringProviderUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getSurveySchemaById?: FieldPolicy<any> | FieldReadFunction<any>,
	healthCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	inReviewClinicalEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyClinicalCriteria?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyExtraction?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyExtractionPayerNames?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyExtractions?: FieldPolicy<any> | FieldReadFunction<any>,
	payerPolicyPayerNames?: FieldPolicy<any> | FieldReadFunction<any>,
	productPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerCheckoutSessionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUser?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedSurveySchema?: FieldPolicy<any> | FieldReadFunction<any>,
	referrals?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReferralKeySpecifier = ('appeal' | 'patientEmail' | 'referralId' | 'referringUser' | ReferralKeySpecifier)[];
export type ReferralFieldPolicy = {
	appeal?: FieldPolicy<any> | FieldReadFunction<any>,
	patientEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	referralId?: FieldPolicy<any> | FieldReadFunction<any>,
	referringUser?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReferralOutputKeySpecifier = ('appealId' | 'denialLetterLinks' | 'medLetterLinks' | 'referralId' | ReferralOutputKeySpecifier)[];
export type ReferralOutputFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	medLetterLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	referralId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SentFaxKeySpecifier = ('completedTimestamp' | 'errorDetails' | 'faxId' | 'faxNumber' | 'initiatedTimestamp' | 'sentStatus' | SentFaxKeySpecifier)[];
export type SentFaxFieldPolicy = {
	completedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	errorDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	faxId?: FieldPolicy<any> | FieldReadFunction<any>,
	faxNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	initiatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	sentStatus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SentLetterKeySpecifier = ('address' | 'currentExpectedDeliveryDate' | 'expectedDeliveryDate' | 'initiatedTimestamp' | 'letterId' | 'lobStatus' | 'recipientName' | 'trackingNumber' | SentLetterKeySpecifier)[];
export type SentLetterFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	currentExpectedDeliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedDeliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	initiatedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	letterId?: FieldPolicy<any> | FieldReadFunction<any>,
	lobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientName?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SponsoredAppealsKeySpecifier = ('totalRemaining' | SponsoredAppealsKeySpecifier)[];
export type SponsoredAppealsFieldPolicy = {
	totalRemaining?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyKeySpecifier = ('createdAt' | 'id' | 'name' | 'surveyData' | 'updatedAt' | 'version' | SurveyKeySpecifier)[];
export type SurveyFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyData?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyAnswerKeySpecifier = ('id' | 'questionText' | 'value' | SurveyAnswerKeySpecifier)[];
export type SurveyAnswerFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	questionText?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveySchemaKeySpecifier = ('condition' | 'createdAt' | 'description' | 'id' | 'isPublished' | 'schemaData' | 'updatedAt' | 'version' | SurveySchemaKeySpecifier)[];
export type SurveySchemaFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	schemaData?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadInfoKeySpecifier = ('appealId' | 'denialLetterInfo' | 'insuranceInfo' | UploadInfoKeySpecifier)[];
export type UploadInfoFieldPolicy = {
	appealId?: FieldPolicy<any> | FieldReadFunction<any>,
	denialLetterInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadLinkKeySpecifier = ('fileExtension' | 'uploadUrl' | UploadLinkKeySpecifier)[];
export type UploadLinkFieldPolicy = {
	fileExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadUrlsKeySpecifier = ('allFilesUploaded' | 'key' | 's3Urls' | UploadUrlsKeySpecifier)[];
export type UploadUrlsFieldPolicy = {
	allFilesUploaded?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Urls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpsertAppealSupportingDocumentResponseKeySpecifier = ('document' | 'uploadUrls' | UpsertAppealSupportingDocumentResponseKeySpecifier)[];
export type UpsertAppealSupportingDocumentResponseFieldPolicy = {
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadUrls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier),
		fields?: AddressFieldPolicy,
	},
	Appeal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealKeySpecifier | (() => undefined | AppealKeySpecifier),
		fields?: AppealFieldPolicy,
	},
	AppealDestination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealDestinationKeySpecifier | (() => undefined | AppealDestinationKeySpecifier),
		fields?: AppealDestinationFieldPolicy,
	},
	AppealLetter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealLetterKeySpecifier | (() => undefined | AppealLetterKeySpecifier),
		fields?: AppealLetterFieldPolicy,
	},
	AppealStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealStatusKeySpecifier | (() => undefined | AppealStatusKeySpecifier),
		fields?: AppealStatusFieldPolicy,
	},
	AppealSupportingDocument?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealSupportingDocumentKeySpecifier | (() => undefined | AppealSupportingDocumentKeySpecifier),
		fields?: AppealSupportingDocumentFieldPolicy,
	},
	AppealSupportingDocumentFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppealSupportingDocumentFileKeySpecifier | (() => undefined | AppealSupportingDocumentFileKeySpecifier),
		fields?: AppealSupportingDocumentFileFieldPolicy,
	},
	Caregiver?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaregiverKeySpecifier | (() => undefined | CaregiverKeySpecifier),
		fields?: CaregiverFieldPolicy,
	},
	CcDestination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CcDestinationKeySpecifier | (() => undefined | CcDestinationKeySpecifier),
		fields?: CcDestinationFieldPolicy,
	},
	ClinicalEvidence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClinicalEvidenceKeySpecifier | (() => undefined | ClinicalEvidenceKeySpecifier),
		fields?: ClinicalEvidenceFieldPolicy,
	},
	Denial?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenialKeySpecifier | (() => undefined | DenialKeySpecifier),
		fields?: DenialFieldPolicy,
	},
	DenialLetter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenialLetterKeySpecifier | (() => undefined | DenialLetterKeySpecifier),
		fields?: DenialLetterFieldPolicy,
	},
	DenialLetterFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenialLetterFileKeySpecifier | (() => undefined | DenialLetterFileKeySpecifier),
		fields?: DenialLetterFileFieldPolicy,
	},
	DenialLetterInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenialLetterInfoKeySpecifier | (() => undefined | DenialLetterInfoKeySpecifier),
		fields?: DenialLetterInfoFieldPolicy,
	},
	DenyingPartyAppealDepartment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DenyingPartyAppealDepartmentKeySpecifier | (() => undefined | DenyingPartyAppealDepartmentKeySpecifier),
		fields?: DenyingPartyAppealDepartmentFieldPolicy,
	},
	Employer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmployerKeySpecifier | (() => undefined | EmployerKeySpecifier),
		fields?: EmployerFieldPolicy,
	},
	GatherClinicalEvidenceResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GatherClinicalEvidenceResultKeySpecifier | (() => undefined | GatherClinicalEvidenceResultKeySpecifier),
		fields?: GatherClinicalEvidenceResultFieldPolicy,
	},
	HistoryQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HistoryQuestionKeySpecifier | (() => undefined | HistoryQuestionKeySpecifier),
		fields?: HistoryQuestionFieldPolicy,
	},
	InReviewClinicalEvidence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InReviewClinicalEvidenceKeySpecifier | (() => undefined | InReviewClinicalEvidenceKeySpecifier),
		fields?: InReviewClinicalEvidenceFieldPolicy,
	},
	InitialReferralData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InitialReferralDataKeySpecifier | (() => undefined | InitialReferralDataKeySpecifier),
		fields?: InitialReferralDataFieldPolicy,
	},
	InsuranceInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsuranceInfoKeySpecifier | (() => undefined | InsuranceInfoKeySpecifier),
		fields?: InsuranceInfoFieldPolicy,
	},
	InsuranceInfoDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsuranceInfoDetailsKeySpecifier | (() => undefined | InsuranceInfoDetailsKeySpecifier),
		fields?: InsuranceInfoDetailsFieldPolicy,
	},
	LetterGeneration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterGenerationKeySpecifier | (() => undefined | LetterGenerationKeySpecifier),
		fields?: LetterGenerationFieldPolicy,
	},
	LetterOfNecessityInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterOfNecessityInfoKeySpecifier | (() => undefined | LetterOfNecessityInfoKeySpecifier),
		fields?: LetterOfNecessityInfoFieldPolicy,
	},
	LetterRevisionHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LetterRevisionHistoryKeySpecifier | (() => undefined | LetterRevisionHistoryKeySpecifier),
		fields?: LetterRevisionHistoryFieldPolicy,
	},
	ManualAppealSendResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualAppealSendResponseKeySpecifier | (() => undefined | ManualAppealSendResponseKeySpecifier),
		fields?: ManualAppealSendResponseFieldPolicy,
	},
	MedicalHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MedicalHistoryKeySpecifier | (() => undefined | MedicalHistoryKeySpecifier),
		fields?: MedicalHistoryFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	PaginatedAppeals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedAppealsKeySpecifier | (() => undefined | PaginatedAppealsKeySpecifier),
		fields?: PaginatedAppealsFieldPolicy,
	},
	PaginatedClinicalEvidence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedClinicalEvidenceKeySpecifier | (() => undefined | PaginatedClinicalEvidenceKeySpecifier),
		fields?: PaginatedClinicalEvidenceFieldPolicy,
	},
	PaginatedInReviewClinicalEvidence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedInReviewClinicalEvidenceKeySpecifier | (() => undefined | PaginatedInReviewClinicalEvidenceKeySpecifier),
		fields?: PaginatedInReviewClinicalEvidenceFieldPolicy,
	},
	PaginatedPayerPolicyClinicalCriteria?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedPayerPolicyClinicalCriteriaKeySpecifier | (() => undefined | PaginatedPayerPolicyClinicalCriteriaKeySpecifier),
		fields?: PaginatedPayerPolicyClinicalCriteriaFieldPolicy,
	},
	PaginatedPayerPolicyExtraction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedPayerPolicyExtractionKeySpecifier | (() => undefined | PaginatedPayerPolicyExtractionKeySpecifier),
		fields?: PaginatedPayerPolicyExtractionFieldPolicy,
	},
	PaginatedProviders?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedProvidersKeySpecifier | (() => undefined | PaginatedProvidersKeySpecifier),
		fields?: PaginatedProvidersFieldPolicy,
	},
	PaginatedReferrals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedReferralsKeySpecifier | (() => undefined | PaginatedReferralsKeySpecifier),
		fields?: PaginatedReferralsFieldPolicy,
	},
	Patient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientKeySpecifier | (() => undefined | PatientKeySpecifier),
		fields?: PatientFieldPolicy,
	},
	PatientInsurance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientInsuranceKeySpecifier | (() => undefined | PatientInsuranceKeySpecifier),
		fields?: PatientInsuranceFieldPolicy,
	},
	PayerPolicyClinicalCriteria?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayerPolicyClinicalCriteriaKeySpecifier | (() => undefined | PayerPolicyClinicalCriteriaKeySpecifier),
		fields?: PayerPolicyClinicalCriteriaFieldPolicy,
	},
	PayerPolicyExtraction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayerPolicyExtractionKeySpecifier | (() => undefined | PayerPolicyExtractionKeySpecifier),
		fields?: PayerPolicyExtractionFieldPolicy,
	},
	Payment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentKeySpecifier | (() => undefined | PaymentKeySpecifier),
		fields?: PaymentFieldPolicy,
	},
	ProductPrices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductPricesKeySpecifier | (() => undefined | ProductPricesKeySpecifier),
		fields?: ProductPricesFieldPolicy,
	},
	Provider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderKeySpecifier | (() => undefined | ProviderKeySpecifier),
		fields?: ProviderFieldPolicy,
	},
	ProviderCheckoutSessionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderCheckoutSessionStatusKeySpecifier | (() => undefined | ProviderCheckoutSessionStatusKeySpecifier),
		fields?: ProviderCheckoutSessionStatusFieldPolicy,
	},
	ProviderFacility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderFacilityKeySpecifier | (() => undefined | ProviderFacilityKeySpecifier),
		fields?: ProviderFacilityFieldPolicy,
	},
	ProviderReferral?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderReferralKeySpecifier | (() => undefined | ProviderReferralKeySpecifier),
		fields?: ProviderReferralFieldPolicy,
	},
	ProviderUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderUserKeySpecifier | (() => undefined | ProviderUserKeySpecifier),
		fields?: ProviderUserFieldPolicy,
	},
	Purchase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PurchaseKeySpecifier | (() => undefined | PurchaseKeySpecifier),
		fields?: PurchaseFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	Referral?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReferralKeySpecifier | (() => undefined | ReferralKeySpecifier),
		fields?: ReferralFieldPolicy,
	},
	ReferralOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReferralOutputKeySpecifier | (() => undefined | ReferralOutputKeySpecifier),
		fields?: ReferralOutputFieldPolicy,
	},
	SentFax?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SentFaxKeySpecifier | (() => undefined | SentFaxKeySpecifier),
		fields?: SentFaxFieldPolicy,
	},
	SentLetter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SentLetterKeySpecifier | (() => undefined | SentLetterKeySpecifier),
		fields?: SentLetterFieldPolicy,
	},
	SponsoredAppeals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SponsoredAppealsKeySpecifier | (() => undefined | SponsoredAppealsKeySpecifier),
		fields?: SponsoredAppealsFieldPolicy,
	},
	Survey?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyKeySpecifier | (() => undefined | SurveyKeySpecifier),
		fields?: SurveyFieldPolicy,
	},
	SurveyAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyAnswerKeySpecifier | (() => undefined | SurveyAnswerKeySpecifier),
		fields?: SurveyAnswerFieldPolicy,
	},
	SurveySchema?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveySchemaKeySpecifier | (() => undefined | SurveySchemaKeySpecifier),
		fields?: SurveySchemaFieldPolicy,
	},
	UploadInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadInfoKeySpecifier | (() => undefined | UploadInfoKeySpecifier),
		fields?: UploadInfoFieldPolicy,
	},
	UploadLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadLinkKeySpecifier | (() => undefined | UploadLinkKeySpecifier),
		fields?: UploadLinkFieldPolicy,
	},
	UploadUrls?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadUrlsKeySpecifier | (() => undefined | UploadUrlsKeySpecifier),
		fields?: UploadUrlsFieldPolicy,
	},
	UpsertAppealSupportingDocumentResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpsertAppealSupportingDocumentResponseKeySpecifier | (() => undefined | UpsertAppealSupportingDocumentResponseKeySpecifier),
		fields?: UpsertAppealSupportingDocumentResponseFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;